export const de = {
    //Topbar
    helpLinkTitle: 'Hilfe',
    signOutActionTitle: 'Abmelden',
    experimentalFeatures: 'Experimentell',
    leaveActionTitle: 'Campus verlassen',
    leaveActionMessage:
        'Um Campus zu verlassen, schließen Sie einfach die Tab in Ihrem Browser. Wenn Sie die Seite von Campus erneut öffnen, kehren Sie direkt zu Ihrem Büro zurück.',
    logOutFromSystem: 'Hier klicken',
    logOutFromSystemTwo: 'um sich abzumelden.',
    changeLocationTo: 'Ort wechseln',
    changeAreaGroupTo: 'Bereich wechseln',
    enterOffice: 'Büro betreten',
    enterOfficeOf: 'Büro betreten von',
    createNewBuilding: 'Neues Gebäude erstellen',
    areaGroup: 'BEREICHSGRUPPE',

    // Identity Panel
    appearenceModification: 'Profilansicht',
    identityPanelTitle: 'Meine Einstellungen',
    profileTabTitle: 'Profil',
    widgetsTabTitle: 'Widgets',
    dashboardWidgetsHeading: 'Persönlicher Schreibtisch',
    dashboardWidgetsHelperText: 'Alle weiteren Widgets können hier ausgeblendet werden, wenn Sie diese nicht auf dem Desktop sehen möchten.',
    dashboardWidgetsMatrixNote:
        'Hinweis: Das Widget für den Matrix-EE2E-Chat wird immer auf dem Desktop für alle Nutzer des CAMPUS angezeigt und kann auch hier nicht ausgeblendet werden.',
    dashboardWidgetOutlookLabel: 'Outlook',
    dashboardWidgetCalendarLabel: 'Kalender',
    dashboardWidgetTasksLabel: 'Aufgaben',
    dashboardWidgetZammadLabel: 'Zammad',
    dashboardWidgetZammadTicketLabel: 'Zammad – Ticket erstellen',
    dashboardWidgetOpenProjectLabel: 'OpenProject',
    dashboardWidgetDocumensoLabel: 'Documenso – E-Signaturen',
    dashboardWidgetColiboLabel: 'Colibo – Newsfeed',
    preferencesTabTitle: 'Präferenzen',
    switchOrgActionTitle: 'Ort wechseln',
    updateImageActionTitle: 'Bild aktualisieren',
    changeEmailActionTitle: 'Email ändern',
    cameraPreferenceActionTitle: 'Kamera beim Betreten eines Raums deaktivieren?',
    microphonePreferenceActionTitle: 'Mikrofon beim Betreten eines Raums deaktivieren?',
    enableCameraActionTitle: 'Kamera beim Betreten aktivieren',
    disableCameraActionTitle: 'Kamera beim Betreten deaktivieren',
    enableMicrophoneActionTitle: 'Mikrofon beim Betreten aktivieren',
    disableMicrophoneActionTitle: 'Mikrofon beim Betreten deaktivieren',
    // Status Actions
    statusAtWork: 'Bei der Arbeit',
    statusAway: 'Kurz abwesend',
    statusDoNotDisturb: 'Bitte nicht stören',
    statusOutOfOffice: 'Nicht am Arbeitsplatz',
    statusOnThePhone: 'Im Gespräch',
    statusCurrent: 'Aktueller Status',
    // At-work location options
    atWorkOptionOffice: 'Büro',
    atWorkOptionRemote: 'Remote',
    atWorkOptionOtherLocation: 'Anderer Ort',
    atWorkCreatePersonalMessage: 'Individuellen Text anzeigen',
    atWorkModalTitle: 'Hinweis erstellen',
    atWorkModalDescription:
        'Geben Sie Ihren eigenen Text ein, der anderen angezeigt wird, wenn Sie bei der Arbeit sind, um Ihren Standort oder Ihre Tätigkeit zu beschreiben.',
    atWorkMessagePlaceholder: 'Geben Sie bitte hier Ihren Standort, eine Statusbeschreibung oder einen Text, der neben Ihrem Profilbild angezeigt wird, ein.',
    // Away Status Options
    awayOptionCoffee: 'Kurz einen Kaffee trinken',
    awayOptionComingBack: 'Gleich zurück',
    awayCustomMessage: 'Für eine kurze Weile nicht am Platz',
    awayCreatePersonalMessage: 'Persönliche Nachricht erstellen',
    awayMessagePlaceholder: 'Geben Sie Ihre Nachricht ein',
    // Custom Away Message Modal
    awayModalTitle: 'Persönliche Abwesenheitsnachricht erstellen',
    awayModalDescription:
        'Geben Sie einen eigenen Text ein, der allen anderen während Ihres Status Gelb angezeigt wird, um ihre kurze Anwesenheit zu kommentieren.',
    awayCharactersLabel: 'Zeichen',
    awayCharactersRemaining: 'verbleibend',
    awayModalConfirm: 'Speichern',
    awayModalCancel: 'Abbrechen',
    awayModalCloseAriaLabel: 'Schließen',
    // Focus Time / Do Not Disturb modal
    focusTimeModalTitle: 'Fokuszeit festlegen',
    focusTimeSelectDuration: 'Dauer wählen',
    focusTime15Min: '15 Min',
    focusTime30Min: '30 Min',
    focusTime45Min: '45 Min',
    focusTime1H: '1 h',
    focusTime1_5H: '1,5 h',
    focusTime2H: '2 h',
    focusTime2_5H: '2,5 h',
    focusTime3H: '3 h',
    focusTimeMaxDurationError: 'Die maximale Dauer beträgt 3 Stunden. Auf 3 Stunden gesetzt.',
    focusTimeStartTimePastError: 'Die Startzeit darf nicht früher als die aktuelle Zeit sein.',
    focusTimeStartOrEndTimePastError: 'Start- oder Endzeit darf nicht früher als die aktuelle Zeit sein.',
    focusTimeMore: 'Mehr',
    focusTimeTotalDuration: 'Gesamtdauer',
    focusTimeSetTimeInterval: 'Zeitintervall festlegen',
    focusTimeStartTime: 'Startzeit',
    focusTimeEndTime: 'Endzeit',
    focusTimeEmergencyQuestion: 'Wie möchten Sie im Notfall kontaktiert werden?',
    focusTimeKnockDoor: 'Durch Einladung in Ihren Raum',
    focusTimeTextMessage: 'Über den Fluid Chat',
    focusTimeDone: 'Fertig',
    focusTimeCancel: 'Abbrechen',
    focusTimeCloseAriaLabel: 'Schließen',
    focusExtendEndModalTitle: 'Fokuszeit beendet seit',
    focusExtendEndModalMessage: 'Möchten Sie Ihre Fokuszeit verlängern oder beenden?',
    focusExtendEndExtend: 'Verlängern',
    focusExtendEndEnd: 'Beenden',
    focusExtendEndCloseAriaLabel: 'Schließen',
    focusWorkUntilEnd: 'Fokusarbeit bis',
    focusTimeEmergencyContactLabel: 'Störung im Notfall via:',
    onPhoneModalTitle: 'Am Telefon',
    onCallModalTitle: 'Im Gespräch',
    onCallModalConfirm: 'Bestätigen',
    onCallModalCancel: 'Abbrechen',
    onCallModalCloseAriaLabel: 'Schließen',
    onCallUntilEnd: 'Im Gespräch bis',
    onCallEndedModalTitle: 'Sind Sie noch am Telefon?',
    onCallEndedForAnother: 'Noch einmal',
    onCallEndedAutoCloseLabel: 'Zurück zu der Arbeit bei fehlender Reaktion in:',
    onCallEndedNo: 'Nein',
    onCallEndedYes: 'Ja',
    onCallEndedCloseAriaLabel: 'Schließen',
    awayExtensionModalTitle: 'Sie scheinen nicht mehr im CAMPUS anwesend zu sein.',
    awayExtensionModalBody: 'Wollen Sie Ihren Status aktualisieren?',
    awayExtensionModalLogoutLabel: 'Wenn Sie nicht reagieren, werden Sie in Kürze in die Lobby geleitet: ',
    awayExtensionModalNo: 'Nein',
    awayExtensionModalYes: 'Ja',
    awayExtensionModalCloseAriaLabel: 'Schließen',
    awayTimeoutAlertTitle: 'Der von Ihnen gewählten Status im CAMPUS entsprach nicht mehr den Gegebenheiten, so dass sie in die Lobby geleitet wurden.',
    awayTimeoutAlertButton: 'Okay, verstanden!',
    lobbyModalInactivityDetectedText: 'Sie wurden in die Lobby begleitet, da Sie auf Nachfragen nicht reagiert haben und länger nicht aktiv waren.',
    lobbyModalInactivityDetectedButton: 'Verstanden',
    lobbyModalOooInactivityText: 'Sie wurden in die Lobby begleitet, da Sie auf Nachfragen nicht reagiert haben und länger nicht aktiv waren.',
    lobbyModalOooInactivityButton: 'Verstanden',
    lobbyModalStatusUpdatedText: 'Sie waren längere Zeit abwesend. Ihr Status wurde auf Abwesend gesetzt und Sie wurden in die Lobby weitergeleitet.',
    lobbyModalStatusUpdatedButton: 'Verstanden',
    lobbyModalMidnightStatusUpdateText:
        'Es ist nach Mitternacht. Ihr Status wurde automatisch auf Abwesend gesetzt und Sie wurden in die Lobby weitergeleitet.',
    lobbyModalMidnightStatusUpdateButton: 'Verstanden',
    lobbyInactivityWarningTitle: 'Lange Abwesenheit',
    lobbyInactivityWarningText: 'Sie waren seit Stunden nicht mehr auf dem CAMPUS aktiv, deshalb werden Sie gleich abgemeldet:',
    lobbyInactivityWarningButton: 'Auf dem CAMPUS bleiben',
    presencePromptTitle: 'Sind Sie noch da?',
    presencePromptButton: 'Ich bin noch da',
    presencePromptIdleChainText: 'Sie waren eine Weile nicht auf dem CAMPUS aktiv. Wenn Sie nicht reagieren, werden Sie in die Lobby verschoben in:',
    presencePromptManualOooTodayText:
        'Sie sind abwesend und waren eine Weile nicht auf dem CAMPUS aktiv. Wenn Sie nicht reagieren, werden Sie in die Lobby verschoben in:',
    presencePromptManualOooLogoutText: 'Sie sind abwesend und waren eine Weile nicht auf dem CAMPUS aktiv. Wenn Sie nicht reagieren, werden Sie abgemeldet in:',
    presencePromptMidnightText:
        'Es ist nach Mitternacht und Sie waren in der letzten Stunde nicht auf dem CAMPUS aktiv. Wenn Sie nicht reagieren, wird Ihr Status auf abwesend gesetzt und Sie werden in die Lobby verschoben in:',
    sessionTakeoverReplacedTitle: 'Campus ist in einem anderen Tab oder auf einem anderen Gerät geöffnet',
    sessionTakeoverReplacedText: 'Sie können Campus immer nur an einem Ort gleichzeitig nutzen.',
    sessionTakeoverUseHereButton: 'Hier verwenden',
    sessionTakeoverOpenElsewhereTitle: 'Campus ist bereits in einem anderen Tab oder auf einem anderen Gerät geöffnet',
    sessionTakeoverOpenElsewhereText: 'Sie können Campus immer nur an einem Ort gleichzeitig nutzen. Möchten Sie es stattdessen hier verwenden?',
    sessionTakeoverKeepOtherButton: 'Dort weiter nutzen',
    sessionTakeoverInCallTitle: 'Sie telefonieren gerade in einem anderen Tab oder auf einem anderen Gerät',
    sessionTakeoverInCallText: 'Wenn Sie hier fortfahren, wird dieser Anruf beendet.',
    sessionTakeoverContinueButton: 'Hier fortfahren',
    sessionTakeoverCancelButton: 'Abbrechen',
    oooReminderTitle: 'Sie werden als abwesend angezeigt',
    oooReminderText: 'Ihr Status ist weiterhin auf abwesend gesetzt und wird anderen angezeigt. Möchten Sie Ihren Status ändern?',
    oooReminderExpiredTitle: 'Ihre Abwesenheit ist abgelaufen',
    oooReminderExpiredText: 'Ihr Abwesenheitsstatus war bis zum {date} gesetzt und wird anderen weiterhin angezeigt. Möchten Sie Ihren Status ändern?',
    oooReminderKeep: 'Abwesend bleiben',
    oooReminderSetAtWork: 'Auf „Bei der Arbeit“ setzen',
    onPhoneModalOptionInCall: 'In einem Anruf',
    onPhoneModalOptionVideoCall: 'In einem Videoanruf',
    onPhoneModalOptionMeetingCall: 'In einer Besprechung',
    onPhoneModalSelectDuration: 'Dauer',
    onPhoneModalConfirm: 'Bestätigen',
    onPhoneModalCancel: 'Abbrechen',
    onPhoneModalCloseAriaLabel: 'Schließen',
    onPhoneUntilEnd: 'Am Telefon bis',
    // Out of Office modal
    oooModalTitle: 'Abwesenheitsstatus festlegen',
    oooModalReturnTime: 'Rückkehrzeit',
    oooModalReturnTimeIn1h: 'in 1 Std.',
    oooModalReturnTimeIn1_5h: 'in 1,5 Std.',
    oooModalReturnTimeIn2h: 'in 2 Std.',
    oooModalReturnTimeIn2_5h: 'in 2,5 Std.',
    oooModalReturnDate: 'Rückkehrdatum',
    oooModalReturnDateToday: 'Heute',
    oooModalReturnDateSetDate: 'Datum festlegen',
    oooModalAbsenceComment: 'Abwesenheitskommentar',
    oooModalAbsenceOptionMeeting: 'In einer Besprechung',
    oooModalAbsenceOptionCustomer: 'Vor Ort beim Kunden',
    oooModalAbsenceOptionLunch: 'In der Mittagspause',
    oooModalAbsenceOptionHolidays: 'OOO - im Urlaub',
    oooModalAbsenceOptionFreshAir: 'Luft schnappen / Spazieren',
    oooModalAbsenceOptionGrocery: 'Einkaufen',
    oooModalAbsenceOptionMultiDayEvent: 'Mehrtägige Veranstaltung',
    oooModalAbsenceOptionOooVacation: 'OOO - Im Urlaub',
    oooModalAbsenceOptionOooSabbatical: 'OOO - Sabbatical',
    oooModalAbsenceOptionOooParentalLeave: 'OOO - Elternzeit',
    oooModalAbsenceOptionOooOutOfOffice: 'OOO - Out of office',
    oooModalAbsenceOption: 'Abwesend',
    oooModalAbsenceHint: 'Aus Liste wählen oder eigene Nachricht eingeben',
    oooModalAbsenceMinCharsError: 'Eigener Kommentar muss mindestens 3 Zeichen haben.',
    oooModalReturnTimePastError: 'Rückkehrzeit darf nicht früher als die aktuelle Zeit sein.',
    oooModalPreferredMethods: 'Bevorzugte Nachrichtenempfangsmethoden',
    oooModalPreferredEmail: 'E-Mail',
    oooModalPreferredChat: 'Über den Fluid Chat',
    oooModalConfirm: 'Bestätigen',
    oooModalCancel: 'Abbrechen',
    oooModalCloseAriaLabel: 'Schließen',
    cameraSettingErrorMessage:
        'Bei der Einstellung Ihrer Geräteeinstellungen ist ein Fehler aufgetreten. Bitte warten Sie einige Zeit und versuchen Sie es erneut. Wenn der Fehler erneut auftritt, wenden Sie sich an den IT-Support.',
    languageSelectionLabel: 'Sprache auswählen',
    languageSelectionPlaceholder: 'Sprache für Textanzeigen wählen',
    languageSelectionActionTitle: 'Ihre präferierte Sprache',
    languageSelectionDescription: 'CAMPUS wird in englischer Sprache angezeigt. In Ordnung?',
    logoutTemporaryButton: 'Hier geht es zum Logout',
    communicationSettings: 'Kommunikationseinstellungen',

    // ProfileImageUploader page
    profileImageUploaderTitle: 'Bild hochladen...',
    //check
    profileImageUploaderDescription: 'Datei hierher ziehen (Drag&Drop) klicken, um eine Datei auszuwählen.',
    profileImageUploaderDescription02: 'Die Datei darf nicht größer als 2 MB sein.',
    profileImageUploaderUploadCapError: 'Die Größe des Bildes, das Sie hochladen möchten, ist größer als 2 Megabytes',

    // Help
    resetTutorialsActionTitle: 'Tutorial erneut starten',
    helpCentreActionTitle: 'Hilfe-Seiten',
    reportErrorActionTitle: 'Fehler melden',
    dialogBoxTitle: 'Tutorials zurücksetzen',
    dialogBoxDescription: 'Bitte diese Seite neu laden, um die Tutorials zu starten!',

    // General
    someone: 'Jemand',
    dismissActionTitle: 'Ablehnen',
    saveActionTitle: 'Speichern',
    saveChangesActionTitle: 'Änderungen speichern',
    savingActionLoadingTitle: 'Speichern...',
    savingActionSuccessTitle: 'Gespeichert!',
    creatingActionLoadingTitle: 'Erstellen...',
    processingRequestActionTitle: 'Verarbeitung Ihrer Anfrage…',
    changesSavedActionTitle: 'Sprachpräferenz gespeichert',
    confirmActionTitle: 'Bestätigen',
    cancelActionTitle: 'Abbrechen',
    closeActionTitle: 'Schließen',
    refreshPageActionTitle: 'Seite aktualisieren',
    backgroundImageTitle: 'Hintergrundbild',
    //check
    typeTitle: 'Gäste-Zutritt zum CAMPUS',
    titleTitle: 'Titel',
    calloutTitle: 'Der Titel wird beim Gästeempfang angezeigt',
    minimumCharacterLimitForTitle: 'Die Mindestanzahl der Zeichen beträgt 2',
    generalTitle: 'Allgemein',
    accessTitle: 'Zutritt',
    editActionTitle: 'Bearbeiten',
    deleteActionTitle: 'Löschen',
    clearActionTitle: 'Entfernen',
    submitActionTitle: 'Senden',
    meetActionTitle: 'Abholen',
    finishActionTitle: 'Fertig',
    okActionTitle: 'Ok',
    clearFilterActionTitle: 'Filter zurücksetzen',
    reconnectToCampusActionTitle: 'Verbindung wiederherstellen',
    sendActionTitle: 'Senden',
    skipActionTitle: 'Überspringen',
    skipActionTitleInCap: 'ÜBERSPRINGEN',
    startButtonLabelInCap: 'START',
    playActionTitle: 'Abspielen',
    pauseActionTitle: 'Pause',
    downloadMicrosoftEdgeActionTitle: 'Microsoft Edge herunterladen',
    enterActionTitle: 'Eintreten',
    talkingToMicrosoftActionTitle: 'Mit Microsoft Identity Platform austauschen...',
    loadingTitle: 'Laden...',
    statusRestoring: 'Status wird wiederhergestellt...',
    authenticatingTitle: 'Authentifizierung...',
    connectingTitle: 'Verbinden...',
    loggedInto: 'Angemeldet bei',
    yesAction: 'Ja',
    noAction: 'Nein',
    connectionLost: 'Verbindung unterbrochen',
    clientConnectionLostDescription1: 'Die Verbindung zum Server wurde unterbrochen.',
    clientConnectionLostDescription2: 'Dies kann verschiedene Gründe haben. Bitte u.a. WLAN prüfen.',
    mobileActionTitle: 'Mobil',
    welcomeBack: 'Willkommen zurück!',
    goodToSeeYouAgain: 'Schön, Sie wiederzusehen.',
    loadingText: 'Authentifizierung mit der ivicos Zugangskontrolle...',
    licenseNotActive: 'Ihre Lizenz scheint nicht gültig zu sein.',
    errorAuthentication: 'Bei der Authentifizierung ist ein Fehler aufgetreten.',
    //check
    usersIn: 'Nutzer in ',
    editMessageActionTitle: 'Nachricht bearbeiten',
    previewActionTitle: 'Vorschau',
    addGifActionTitle: 'Gif-Grafik hinzufügen',
    removeActionTitle: 'Entfernen',
    back: 'Zurück',
    of: 'von',
    discard: 'Verwerfen',
    save: 'Speichern',
    cancel: 'Abbruch',
    removeImage: 'Bild entfernen',
    later: 'Später',
    writeUs: 'Schreiben Sie uns',
    talkToSales: 'Vertrieb kontaktieren',
    benefitsMissing: 'Entgehende Vorteile…',
    campusRestored: 'Ihr Campus wurde erfolgreich wiederhergestellt!',

    // visitor landing page
    landingPageEnterName: 'Bitte geben Sie hier Ihren Namen ein',
    landingPageEnterNameCallOutPart1: 'Bitte geben Sie Ihren Namen, einen Spitznamen oder Psydonym ein.',
    landingPageEnterNameCallOutPart2: 'Diese Information wird nicht in unserem System gespeichert und gelöscht, sobald Sie den CAMPUS verlassen.',
    landingPagePrivacyHint: 'Datenschutzhinweise: Fragezeichen anklicken.',
    landingPageGoIn: 'Eintreten',
    landingPageAudioCallOut: 'Diese Anzeige dient dem Test der lokalen Mikrofon-Freigabe. Es werden nirgendwohin Daten übertragen.',
    landingPageSetAudioDevices: 'Audiogeräte einstellen',
    landingPageRisk: 'Mit dem von Ihnen verwendeten Browser könnte die Bedienung etwas umständlicher sein.',
    landingPageWeRecommend: 'Wir empfehlen:',
    landingPageRiskCallOutPart1: 'Einige Browser weichen hin und wieder stärker von Standard ab,so dass sie manchmal zu Inkompatibilitäten führen.',
    landingPageRiskCallOutPart2: 'Aus diesem Grund können wir derzeit die Verwendung von Safari oder Firefox nicht empfehlen, wenngleich sie möglich.',
    landingPageHeaderTitle: 'Audio & Video Einstellungen',

    // waitingArea
    waitingAreaHelloVisitor: 'Hallo',
    waitingAreaWaitBriefly: 'Bitte warten Sie kurz:',
    waitingAreaHostInformed: 'Ihr Gastgeber wurde soeben über Ihre Ankunft informiert.',
    waitingAreaNoOneGreet: 'Es scheint niemand gekommen zu sein, um Sie zu begrüßen:',
    waitingAreaClickAgain: 'Bitte klicken Sie auf die Schaltfläche mit der Glocke unten, um eine weitere Benachrichtigung über Ihre Anwesenheit zu senden.',
    waitingAreaNotifyHost: 'Host benachrichtigen',

    // invalid invitation link
    insertedLinkIncorrect: 'Der eingefügte Link scheint falsch oder unvollständig zu sein!',
    verifyAccuracyOfInvitationLink: 'Bitte überprüfen Sie die Vollständigkeit des Links und kopieren Sie ihn erneut in einen Browser-Tab.',
    invalidInvitationProblemPersists: 'Wenn das Problem weiterhin besteht, wenden Sie sich bitte an unseren ',
    supportServiceHere: 'Support',

    // Campus Settings
    lobbyImageTitle: 'Hintergrundbild der Lobby',
    changeColorActionTitle: 'Farbe anpassen',
    changeLogoActionTitle: 'Logo ändern',
    changeImageActionTitle: 'Bild auswählen',
    changeImageCalloutTitle: 'Dieses Bild wird im Hintergrund Ihres Besuchereingangs erscheinen. Die Dateigröße muss bis zu 2 MB betragen.',
    changeLobbyBgImageTitle: 'Dieses Bild wird im Hintergrund der Lobby angezeigt. Die Dateigröße darf bis zu 2 MB betragen.',
    visitorEntranceYTTitle: 'Video für das Wartezimmer',
    instructionToSetVideoAtVisitorEntrance:
        'Dieses Video wird Gästen zur Ansicht angeboten, wenn Sie im Gästeempfang auf einen Abholer warten. Das Video ersetzt das in den CAMPUS-Einstellungen als Standard festgelegte Video.',
    pasteYTVideo: 'Hier einen YouTube-Videolink einfügen',
    changeYTVideo: 'Video ändern',
    selectYTVideo: 'Video auswählen',
    changeColorCalloutTitle: 'Wählen Sie hier Ihre Unternehmens-Farbe die u.a. in der Kopfzeile Ihres CAMPUS dargestellt wird.',
    changeLogoCalloutTitle:
        'Das Logo erscheint in Ihrer Kopfzeile und in Ihrem Wartebereich auf Ihren CAMPUS. Die Größe sollte 250 x 100 Pixel betragen. Sie kann jedoch je nach Logo-Format variieren.',
    //check
    ownershipTitle: 'CAMPUS Eigentümer',
    transferOwnershipActionTitle: 'Rolle des Eigentümers übertragen',
    transferActionTitle: 'Übertragen',
    transferOwnershipError:
        'Bei der Übertragung der Eigentümerschaft ist ein Fehler aufgetreten. Bitte versuchen Sie, die Eigentumsübertragung erneut vorzunehmen, und wenden Sie sich an den Support, wenn der Fehler erneut auftritt.',
    transferOwnerShipDescriptionTitle:
        'Nach der Übertragung der Eigentümerschaft sind Sie nicht mehr der Eigentümer dieses Campus. Bitte bedenken Sie dies vorab!',
    currentManagersListTitle: 'Liste der derzeitigen CAMPUS-Manager',
    searchManagersPlaceholder: 'Suche CAMPUS-Manager',
    managerDetailsListTitle: 'Details zu den Managern',
    transferOwnershipWarningTitle1: 'Wenn Sie auf Bestätigen klicken, ändern sich die Eigentumsrechte auf ',
    transferOwnershipWarningTitle2: ' und Sie werden zum CAMPUS-Manager.',
    brandIdentityTitle: 'Markenidentität',
    campusDesignTitle: 'CAMPUS-Design',
    visitorEntranceDesignTitle: 'Gästeempfang-Design',
    campusNameTitle: 'CAMPUS Name',
    campusColorTitle: 'Farbe',
    campusLogoTitle: 'Logo',
    saveCampusSettingsDescription: 'Klicken Sie auf "Bestätigen", um die von Ihnen vorgenommenen Änderungen zu speichern.',
    accessMethodTitle: 'Alternative Nutzeranmeldung',
    switchOnDescription: 'Schalten Sie das Single-Sign-On von Microsoft 365 für alle CAMPUS-Mitglieder ein.',
    switchOffDescription: 'Alle Mitarbeiter Ihres Microsoft-Tenant werden so bei der Anmeldung gebeten, diesem Campus beizutreten.',
    accessMethodCallout1: 'Sie können Ihren CAMPUS mit Ihrer Microsoft-Tenant verbinden.',
    accessMethodCallout2: 'Auf diese Weise wird jeder in Ihrer Microsoft-Organisation bei der Anmeldung aufgefordert, diesem CAMPUS beizutreten.',
    confirmDescription: 'Sind Sie sicher, dass Sie für Ihre Organisation eine Microsoft-Single-Sign-On freischalten wollen?',
    OwnershipTransferredActionTitle: 'Eigentümerschaft übertragen',
    signOutAndSignInError: 'Bitte melden Sie sich vom CAMPUS ab und dann erneut an, damit die Änderungen wirksam und sichtbar werden.',
    errorOccurred: 'Es ist ein Fehler aufgetreten',
    removeOrganizationButton: 'Organisation entfernen',
    removeOrganizationChoiceAccept: 'Ja, ich bin mir sicher',
    removeOrganizationChoiceRefuse: 'Nein, ich möchte es nicht entfernen',
    removeOrganizationQuestion: 'Sind Sie sicher, dass Sie [org] entfernen möchten?',
    removeOrganizationExplanation:
        'Dies bedeutet, dass alle Mitglieder, Bereiche, Räume und Dokumente, die auf dem Campus dieser Organisation erstellt wurden, verloren gehen.',
    removeOrganizationModalTitle: 'Organisation entfernen',
    isSavingChanges: 'Änderungen werden gespeichert...',
    externalDoorsTitle: 'Öffnungszeiten',
    externalDoorsAdminCenterTitle: 'Administration von Zugängen für Externe zu diesem Campus',
    externalDoorsCurrentDateTime: 'Es ist [date] – [time] Uhr',
    externalDoorsCreateEditAccessPassesTitle: 'Zugang erstellen/bearbeiten',
    externalDoorsSecurityLevels: 'mit verschiedenen Sicherheitsstufen',
    externalDoorsAccessMethods: 'Zugangsmethoden (Abholung, direkt)',
    externalDoorsBankHolidays: 'unter Berücksichtigung von Feiertagen und/oder',
    externalDoorsOpeningHours: 'organisatorischen Öffnungszeiten.',
    externalDoorsCreateEditExteriorDoorsButton: 'Zugang erstellen oder bearbeiten',
    externalDoorsOverviewTitle: 'Eine Übersicht über bestehende Zugänge',
    externalDoorsOverviewSecurityComfort: 'um sicherzustellen, dass sie dem gewünschten Sicherheits- und Komfortniveau für Benutzer entsprechen',
    externalDoorsOverviewControl: 'um auch bei vielen Zugängen für Externe die Kontrolle zu behalten.',
    externalDoorsEnterControlRoomButton: 'Zugangs-Cockpit',

    // Auth
    loginPromptTitle: 'Bitte authentifizieren Sie sich!',
    loginPromptDescription: 'Melden Sie sich mit Ihrem Microsoft-Zugangsdaten an, die Sie von Ihrem Unternehmen erhalten haben...',

    // Notifications
    meetNotificationActionTitle: 'Sich treffen',
    inviteNotificationActionTitle: 'Einladen',
    acceptNotificationActionTitle: 'Annehmen',
    answerNotificationTitle: 'Antworten',
    //check
    doorKnockNotificationBody: 'Wollen Sie die Person herein lassen?',
    doorKnockConfirmationNotificationBody: 'Sie haben an der Tür des Raums: {roomName} geklopft!',
    memoSentNotificationBody: 'Die Person wurde benachrichtigt',
    noUsersWarning: 'Es ist niemand da, der benachrichtigt werden könnte.',
    showDetailsActionTitle: 'Details anzeigen',
    meetThemActionTitle: 'Sich treffen',
    visitorIsWaitingNotificationTitle: 'ist an der Tür!',
    visitorIsWaitingNotificationBody: 'Wollen Sie die Person treffen?',
    visitorFor: 'Für: ',
    visitorHost: 'Gastgeber: ',
    visitorIsWith: ' ist im Besucherempfang bei ',
    visitorWithOthers: ' und andere sind mit ',
    memoSentToNotificationActionTitle: 'Nachricht gesendet an ',
    somethingWentWrongNotificationActionTitle: 'Etwas ist schief gelaufen',
    invitationSentNotificationActionTitle: 'Einladung abgeschickt!',
    inputSupportsMarkdownTitle: 'Dieses Feld unterstützt die sog. Markdown-Schreibweise (klicken Sie, um mehr zu erfahren)',
    inviteVisitorNotificationBody: 'Wollen Sie den Besucher empfangen?',
    youHaveTheGuestMessage: 'Ein Gast befindet sich im Wartebereich!',
    successMessage: 'Erfolgreich!',
    inviteYouToMessage: 'lädt Sie in den/die',
    inviteYouToMessage1: 'lädt Sie in ihr/sein persönliches Büro ein',
    invitedYouToMessage: 'lud Sie in den/die',
    invitedYouToMessage1: 'lud Sie in ihr/sein persönliches Büro ein',
    inviteYouToMessage2: 'ein',
    saysMessage: 'sagt:',
    saidMessage: 'sagte:',
    isAtYourDoorMessage: 'ist an der Tür',
    wasAtYourDoorMessage: 'war an der Tür',
    someoneMessage: 'Jemand',
    replyActionTitle: 'Antworten',
    inviteThemInActionTitle: 'Hereinlassen',
    acceptInvitationActionTitle: 'Einladung annehmen',
    userAlreadyExists: 'Benutzer bereits vorhanden',
    sendMemoToActionTitle: 'Nachricht senden an',

    // Grouped Notifications
    closeAllMemosAndInvitations: 'Alle Memos und Einladungen schließen',
    closeAllMemos: 'Alle Memos schließen',
    closeAllInvitations: 'Alle Einladungen schließen',
    closeAllVisitorNotifications: 'Alle Besucher Benachrichtigungen schließen',
    closeAllMessages: 'Alle Nachrichten schließen',
    closeAllMessageDialogSubText1: 'Wenn Sie dieses Fenster schließen, verlieren Sie alle ihre ',
    onlyMemos: 'Memos',
    onlyInvitations: 'Einladungen',
    memosAndInvitations: 'Memos und Einladungen',
    onlyVisitorNotifications: 'Besucher Benachrichtigungen',
    onlyMessages: 'Nachrichten',
    closeAllMessageDialogSubText2: 'Sind Sie sicher?',
    closeAllMessageDialogNo: 'Nein',
    closeAllMessageDialogYes: 'Ja',
    seekingAttention: 'bittet um ihre Aufmerksamkeit!',
    wasSeekingAttention: 'suchte Ihre Aufmerksamkeit!',
    thereAreVisitors: 'Jemand ist am Besucherempfang!',
    youHave: 'Sie haben ',
    unreadMemos: 'ungelesene Nachricht(en) ',
    notificationDescriptionAnd: 'und ',
    ignoredInvitations: ' ignorierte Einladung(en).',
    visitorsWaiting: ' Besucher, die auf Sie warten.',
    viewAll: 'Alle anzeigen',
    hideAll: 'Alle ausblenden',
    closeAll: 'Alle schließen',

    //User Actions
    inviteUserToRoomActionTitle: 'In Ihr Zimmer einladen',
    sendUserMemoActionTitle: 'Nachricht senden',
    kickOutVisitorActionTitle: 'Besucher aus dem CAMPUS entfernen',
    redirectUserActionTitle: '{userOrVisitor} aus meinem persönlichen Büro hinauskomplimentieren',
    inAMeetingActionTitle: 'In einem Gespräch',
    userIsInAMeetingActionTitle: '{User} ist in einem Gespräch!',
    userIsInAMeetingActionText: 'Möchten Sie {User} weiterhin eine Nachricht senden?',
    redirectUserModal: {
        title: 'Möchten Sie {username} wirklich aus Ihrem persönlichen Raum entfernen?',
        text1: 'Das könnte als unhöflich empfunden werden.',
        text2: 'Zu Ihrer Information: Dieser Nutzer wird eine Nachricht erhalten, dass Sie ihn aus Ihrem Büro heraus geschoben haben, um ihr Büro wieder alleine nutzen zu können.',
        yes: 'Ja',
        no: 'Nein',
        confirmationText: '{username} wurde erfolgreich aus Ihrem persönlichen Raum entfernt.',
        errorText: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
        closeButton: 'Schließen',
        informationModal: {
            title: '{username} hat Sie aus seinem persönlichen Raum begleitet.',
            text: 'Bitte verstehen Sie dies nicht als unhöfliche Geste. {username} wollte sein persönliches Büro einfach wieder alleine nutzen.'
        }
    },

    // Sidebar
    personalRoomsSectionTitle: 'Persönliche Büroräume',
    commonRoomsSectionTitle: 'Räume',
    commonRoomsSectionEmptyNoticeTitle: 'Keine Zimmer in diesem Bereich',
    commonRoomsSectionEmptyNotice: 'Sie können unten Zimmer hinzufügen.',

    // Member Invites
    inviteMemberLabelTitle: 'zu dieser Organisation',
    inviteAnyoneLabelTitle: 'von ausserhalb dieser Organisation',
    inviteMemberLabel: 'Personen hinzufügen',
    inviteMemberPlaceholder: 'E-Mail-Adresse',
    inviteMemberErrorMessage: 'Ungültige E-Mail Adresse',
    InviteRoleErrorMessage: ' ist nicht gültig, bitte wählen Sie einen Mitglied oder Manager',
    inviteLanguageErrorMessage: ' ist nicht gültig, bitte wählen Sie English oder Deutsch',
    inviteMemberDescription1:
        'Dies ist eine Mitglieder-Einladung für eine einzelne Person. Nach dem Versenden der Einladung wird die Person per E-Mail benachrichtigt und sie erscheint in der Mitgliederliste.',
    inviteMemberDescription2:
        'Verwenden Sie eine .csv-Datei, um mehrere Mitglieder gleichzeitig einzuladen. Nach dem Versenden der Einladung werden die Personen per E-Mail benachrichtigt und sie erscheinen in der Mitgliederliste.',
    ImportCSVFileTitle1: 'CSV-Datei importieren',
    ImportCSVFileTitle2: 'Einladungen überprüfen',
    ImportCSVFileTitle3: 'Einladungsprozess initiiert...',
    ImportCSVFilePlaceholder: 'Ziehen Sie eine .csv-Datei auf diese Feld (Drag&Drop), oder klicken Sie auf das Feld hier, um eine Datei auszuwählen.',
    downloadCSVTemplateFileLabel: 'Eine .CSV-Vorlagendatei zum Ausfüllen herunterladen',
    changeFileActionTitle: 'Datei ändern',
    inviteThesePeopleActionTitle: 'Diese Personen einladen',
    inviteThesePeopleConfirmDescription: 'Sind Sie sicher, dass Sie diese Personen einladen wollen?',
    emailTitleLabel: 'E-Mail Adresse',
    emailTitlePlaceholder: 'Geben Sie eine Arbeits-E-Mail-Adresse ein',
    roleTitleLabel: 'Rolle',
    languageTitleLabel: 'Sprache',
    rolePlaceHolder: 'Wählen Sie eine Rolle',
    inviteSingleUserTitle: 'Ein einzelnes Mitglied hinzufügen',
    inviteMultipleUserTitle: 'Mehrere Mitglieder hinzufügen',
    bulkInviteDescription1: 'Die Einladung von mehreren Mitgliedern gleichzeitig funktioniert mithilfe einer ',
    bulkInviteDescription2:
        ' Datei, die alle E-Mail-Adressen der einzuladenden Personen listet. Die neu eingeladenen Personen erscheinen dann in der Mitgliederliste.',
    sendInviteButtonTitle: 'Einladung versenden',
    sendInvitesButtonTitle: 'Einladungen versenden',
    openBulkInviteButtonTitle: 'Mehrere Personen hinzufügen',
    confirmBulkInviteQuestion1: 'Sind Sie sicher, dass Sie diese Mitglieder-Einladungen versenden möchten?',
    confirmBulkInviteQuestion2: 'Sind Sie sicher, dass Sie diese Mitglieder-Einladung versenden möchten?',
    bulkInviteStep1Title: 'Schritt 1:',
    bulkInviteStep2Title: 'Schritt 2:',
    bulkInviteStep1Description:
        'Laden Sie bitte diese Datei/Vorlage auf Ihren Computer und listen Sie die E-Mail-Adressen von Personen, die Mitglieder Ihres CAMPUS werden sollen.',
    bulkInviteStep2Description: 'Um gleichzeitig mehrere Mitglieder hinzuzufügen, bitte unten die von Ihnen ausgefüllte Datei hochladen.',
    invitationAlreadySent: 'Einladung bereits versandt',
    successfullyInvited: 'Erfolgreich eingeladen!',
    inactiveAccountInvited: 'Inactive account',
    invitedSponsorTooltipYourList: 'Diese Person ist in Ihrer Rechnungsliste enthalten',
    invitedSponsorTooltipOtherList: 'Diese Person steht auf einer anderen Rechnungsliste',

    // Invitations
    createInvitationTitle: 'Zugangsberechtigung',
    createInvitationButtonTitle: 'Zugangsberechtigung erstellen',
    inviteMemberActionTitle: 'Neues Mitglied einladen',
    bulkInviteActionTitle: 'Mehrere Mitglieder einladen',
    resendInvitationActionTitle: 'Einladung erneut versenden?',
    resendInvitationActionDescription: 'Sind Sie sicher, dass Sie die Einladung erneut an folgende Adresse senden möchten ',
    reviewInvitationTitle: 'Review invitations',
    reviewInvitationDescription1: 'One or more people could not be invited as they have no active account.',
    reviewInvitationDescription2: 'However, their invitations can be reworked at any time by filtering the table by Inactive.',
    reviewInvitationClose: 'Close',
    deleteInvitationActionTitle: 'Einladung löschen',
    deleteInvitationActionTitle2: 'Zugangsberechtigung löschen',
    deleteInvitationActionDescription: 'Sind Sie sicher, dass Sie diesen Benutzer keinen Zugang mehr zum CAMPUS ermöglichen möchten?',
    invitationsManagerTitle: 'Besucher-Einladungsmanagement',
    invitationsTitle: 'Einladungen',
    waitingVisitorsTitle: 'Gäste im Empfangsraum',
    filterInvitationsPlaceholder: 'Einladungen filtern',
    upcomingInvitationsTitle: 'Anstehende Gästeeinladungen',
    recurringInvitationsTitle: 'Sich wiederholende Gästeeinladungen',
    showExpiredInvitationsActionTitle: 'Auch abgelaufene Einladungen anzeigen',
    noVisitorsDescriptionTitle: 'Derzeit gibt es keine Gäste auf dem CAMPUS',
    areaTitle: 'Bereich',
    roomTitle: 'Raum',
    hostsTitle: 'Benachrichtigen',
    welcomeMessageTitle: 'Begrüßungsnachricht',
    missingWelcomeMessageTitle: 'Keine Begrüßungsnachricht eingegeben.',
    validityTitle: 'Gültigkeit',
    validTitle: 'Gültig',
    validFromTitle: 'gültig von',
    onTitle: 'On',
    selectedHostTitle: 'Ausgewählte Gastgeber',
    hostSelectorDescription: 'Diese Gastgeber werden dann über die Ankunft eines Besuchers benachrichtigt.',
    hostSelectorPlaceholder: 'Tippen Sie hier, um Gastgeber auszuwählen',
    invitationValidityCallout:
        'Einmalige Einladungen sind für das unten angegebene Datum gültig, während wiederkehrende Einladungen in einer bestimmten Häufigkeit wiederholt werden.',
    invitationTypeCallout:
        'Im Falle eines direkten Zugangs können Besucher nach der Namenseingabe direkt einen definierten Raum betreten, während sie im Falle einer Abholung zunächst im Wartebereich vom Gastgeber abgeholt werden müssen.',
    invitationDeleteConfirm: 'Sind Sie sicher, dass Sie diesen Einladungslink löschen möchten?',
    eventTypeSingle: 'Einmalig',
    eventTypeRecurring: 'Wiederkehrend',
    InvitationTypeDirect: 'Direkter Zutritt eines Bereichs',
    InvitationTypePickup: 'Abholung durch einen Gastgeber',
    RecurringTypeEveryDay: 'Jeden Tag',
    RecurringTypeEveryWeek: 'Jede Woche',
    invitationDeleteConfirm2: 'Sind Sie sicher, dass Sie Folgendes löschen möchten',
    copyFailedActionTitle: 'Kopieren fehlgeschlagen!',
    copyActionTitle: 'Link kopieren',
    copiedActionTitle: 'Link kopiert!',
    manageAccessTitles: 'Zugang verwalten',
    msEnabledTitle: 'MS Single-Sign-On: eingeschaltet',
    suggestionsHeaderText: 'Vorgeschlagene Personen',
    mostRecentlyUsedHeaderText: 'Vorgeschlagene Kontakte',
    noResultsFoundText: 'Kein Ergebnis gefunden',
    loadingTitleText: 'Applikation laden',
    suggestionsAvailableAlertText: 'Personenauswahl - Vorschläge verfügbar',
    suggestionsContainerAriaLabel: 'Vorgeschlagene Kontakte',
    invitationSendButtonText: 'Erstellen',
    invitationEmailSubject: 'Anbei erhalten Sie von {orgName} eine Zugangsberechtigung zum Campus',
    invitationEmailBody: `Titel: {invName}%0D%0A
    %0D%0AGültigkeit: {frequency} von {validFromTime} bis {validToTime}%0D%0A
    %0D%0AZutrittslink: {invitationLink}%0D%0A
    %0D%0A
    %0D%0A===================================================%0D%0A
    %0D%0A
    %0D%0ALernen Sie ivCAMPUS kennen: https://ivicos.eu%0D%0A
    `,
    createAndContinue: 'Erstellen und weiter',
    updateInviationTitle: 'Ihre Zugangsberechtigung ist fertig und sieht so aus:',
    editCustomUrlTitle: 'Link-Vorschau',
    editCustomUrl: 'Endung anpassen',
    customUrlCallout:
        'Hier kann die Endung der Zugangsberechtigungslink nach Belieben geändert werden. Beilspielsweise kann ein Titel einer Veranstaltung oder der Name einer einzuladenden Person genutzt werden. Bitte verwenden Sie keine Sonderzeichen.',
    calendarIntegrationTitle: 'Sie können auch zwischen den folgenden Möglichkeiten wählen:',
    calendarIntegrationButton: 'Zum Kalender hinzufügen und/oder .ics-Datei herunterladen',
    invitationToEmailButton: 'An E-Mail Adresse(n) senden',
    downloadInvitation: '.ics-Datei herunterladen ',

    // Custom Url Modal
    customUrlModalTitle: 'Einladungslink individualisieren',
    customUrlModalDescription1:
        'Hier kann die Endung des Einladungslinks nach Belieben geändert werden. Beilspielsweise kann ein Titel einer Veranstaltung oder der Name einer einzuladenden Person genutzt werden. Beim Schließen der Seite oder Klick auf "Verwerfen" wird die Einladung mit einer zufällig generierten Endung versehen.',
    customUrlModalDescription2: 'Bitte keine Sonderzeichen verwenden.',
    customUrlModalErrorNoSpecialCharacters: 'Sonderzeichen können nicht verwendet werden!',
    customUrlModalErrorMaximumLimit: 'Die maximale Zeichenanzahl beträgt 50!',
    customUrlModalErrorMinimumLimit: 'Die Mindestanzahl der Zeichen beträgt 1!',
    customUrlModalErrorCustomUrlExists: 'Dieser Einladungslink existiert bereits!',
    customUrlModalLinkAppearance: 'Vorschau des Einladungslinks:',
    customUrlModalDiscard: 'Verwerfen',
    customUrlModalSaveAndCopy: 'Speichern und kopieren',

    // Customized video url
    customizedVideoLabel: 'Standardvideo für das Wartezimmer verwenden',
    customizedVideoCallOutPart1: 'Dieses Video wird Gästen zur Ansicht angeboten, wenn Sie im Gästeempfang auf einen Abholer warten.',
    customizedVideoCallOutPart2: 'Das Video ersetzt das in den CAMPUS-Einstellungen als Standard festgelegte Video.',
    customizedVideoOn: 'An',
    customizedVideoOff: 'Aus',
    customizedVideoPasteLink: 'YouTube Link einfügen',

    // Visitors
    visitorTabTitle: 'Gäste',
    visitorEntranceTitle: 'Gästeempfang',
    farewellMessageTitle: 'Nachricht zur Verabschiedung',
    farewellMessageCallout:
        'Alle Besucher eines CAMPUS können mit einem einfachen Klick aus dem CAMPUS entfernt werden. Hierzu einfach die Maus über den entsprechenden Besucherausweis bewegen. Entsprechenden Nutzern wird daraufhin eine hier festgelegte Verabschiedungsnachricht angezeigt.',
    visitorLinkTitle: 'Ihr Einladungslink',
    visitorLinkDescription: 'Teilen Sie diesen Link, um andere zu diesem Bereich einzuladen. Sie werden benachrichtigt, sobald ein Besucher eintrifft.',
    copyButtonLabel: 'Einladungslink in die Zwischenablage kopieren',
    copyButtonSuccessLabel: 'Link kopiert!',
    copyButtonErrorLabel: 'Fehler',
    letVisitorInsideActionTitle: 'Gewähren Sie Zutritt',
    letVisitorInActionTitle: 'Dorthin begleiten',
    meetVisitorActionTitle: 'Treffen',
    dialogYourInvitationSent: 'Ihre Einladung wurde versandt! Hinweis: Es kann bis zu 5 Minuten dauern, bis der Empfänger sie erhält.',
    dialogPersonNotAddedToBillingList1: 'Das Konto der Person, die Sie eingeladen haben, ist aktiviert, so dass es nicht in die Liste der ',
    dialogPersonNotAddedToBillingList2: '-Rechnung aufgenommen wird.',
    dialogPersonDoesNotHaveActiveAccountTitle: 'Inaktives Konto',
    dialogPersonDoesNotHaveActiveAccount1: 'Die Person, die Sie einladen möchten, hat kein aktives Benutzerkonto.',
    dialogPersonDoesNotHaveActiveAccount2: 'Möchten Sie den Nutzer zu Ihrer Organisation hinzufügen?',
    dialogWeDidNotSendInvitationTitle: 'Einladung wurde nicht verschickt!',
    dialogPersonDoesNotHaveActiveAccount3: 'Wir haben keine Einladung versendet, da der Nutzer noch nicht auf dem ivCAMPUS registriert ist.',
    dialogPersonDoesNotHaveActiveAccount4:
        'Bitten Sie diese Person, der nicht Ihrer Organisation zugeordnet werden soll, dass er für seine Organisation einen eigenen CAMPUS anlegt. Sobald er auf der Plattform registriert ist, kann er auf Ihren Campus eingeladen werden.',
    dialogPersonDoesNotHaveActiveAccountNo: 'Nein',
    dialogPersonDoesNotHaveActiveAccountYes: 'Ja',
    dialogIsAlreadyAMember: ' ist bereits ein Mitglied',
    notActiveMessageDaily: 'Ihre Einladung mit dem Titel {eventName} ist täglich gültig von {timeFrom} bis {timeTo}.',
    notActiveMessageWeekly: 'Ihre Einladung mit dem Titel {eventName} ist wöchentlich gültig von {dayFrom} um {timeFrom} bis {dayTo} um {timeTo}.',
    notActiveMessageSingle: 'Ihre Einladung mit dem Titel {eventName} ist gültig von {completeDateFrom} Uhr bis {completeDateTo} Uhr.',
    youAreTalkingTo: 'Sie sprechen mit',
    directVisitorToRoom: 'Besucher mitnehmen',
    thanksForVisitMessage: 'Danke für Ihren Besuch!',
    VisitorExitDescription1: 'Ihr Besuch wurde ermöglicht durch ivicos CAMPUS.',
    VisitorExitDescription2: 'Erfahren Sie mehr auf',
    VisitorExitDescription3: 'ivicos.eu',
    invitationLinkNotValid: 'Derzeit ist der Besuchereingang geschlossen. Deshalb führt sie ihr Link derzeit nicht weiter.',
    errorInButton: 'Fehler',
    backToAreaButton: 'Zurück',
    roomIsOccupied: 'ist derzeit besetzt',
    manageEntranceButton: 'Besucher mitnehmen',
    // Area Actions
    addAreaActionTitle: 'Bereich',
    addAnAreaActionTitle: 'Neuen Bereich hinzufügen',
    addAreaGroupActionTitle: 'Neue Bereichsgruppe hinzufügen',
    editAreaActionTitle: 'Bereich bearbeiten',
    editAreaGroupActionTitle: 'Bereichsgruppe bearbeiten',
    deleteAreaActionTitle: 'Bereich löschen',
    deleteAreaGroupActionTitle: 'Bereichsgruppe löschen',
    searchAreasPlaceholder: 'Bereiche filtern',
    createAreaTitle: 'Neuen Bereich erstellen',
    createAreaGroupTitle: 'Neue Bereichsgruppe erstellen',
    enterAreaNameLabel: 'Bereichsname',
    enterAreaTagLabel: 'Bereichstitel',
    enterAreaGroupNameLabel: 'Bereichsgruppename',
    enterAreaGroupTagLabel: 'Bereichsgruppentitel',
    enterAreaNamePlaceholder: 'Neuen Bereichsnamen eingeben',
    enterAreaGroupNamePlaceholder: 'Neuen Bereichsgruppenamen eingeben',
    enterAreaTagPlaceholder: 'Neuen Bereichstitel eingeben',
    enterAreaGroupTagPlaceholder: 'Neuen Bereichsgruppentitel eingeben',
    enterAreaSortNumberLabel: 'Sortierung (0–1000)',
    enterAreaGroupSortNumberLabel: 'Sortierung (0–1000)',
    enterAreaSortNumberPlaceholder: '0–1000',
    enterAreaGroupSortNumberPlaceholder: '0–1000',
    enterAreaSortNumberError: 'Geben Sie eine ganze Zahl von 0 bis 1000 ein.',
    areaPreview: 'Vorschau',
    deleteAreaDescription: 'Sind Sie sicher, dass Sie Folgendes löschen möchten:',
    areaLeaveConfirmDescription: 'Sind Sie sicher, dass Sie diesen Bereich verlassen wollen?',
    panelTitle: 'Navigator',
    showMoreOptionsTooltip: 'Weitere Optionen anzeigen',
    maxFavoriteAreasReached: {
        title: 'Maximale Auswahl an Favoritenbereichen erreicht.',
        description:
            'Sie können nur 2 Favoritenbereiche als Abkürzung zur Darstellung in der Navigationsleiste auswählen. Klicken Sie auf ein ausgefülltes Sternsymbol, um die Auswahl eines Favoritenbereichs aufzuheben, und klicken Sie dann erneut auf diesen Stern, um diesen Bereich als Favoriten zu markieren.',
        close: 'Hinweis ausblenden'
    },
    allAreasDeletedPart1: 'Alle Bereiche mit Räumen wurden gelöscht!',
    allAreasDeletedPart2: 'Sie können jetzt hier neu Bereiche hinzufügen.',

    // Area Actions / Search Person
    crossAreaSearchPersonIconTitle: 'Person finden',
    crossAreaSearchPersonPanelHeaderTitle: 'Person finden',
    crossAreaSearchPersonPanelCloseButton: 'Schließen',
    crossAreaSearchPersonSearchBarPlaceholder: 'Suchen',
    crossAreaSearchPersonThisArea: 'diesem Bereich',
    crossAreaSearchPersonOtherArea: 'einem anderen Bereich (dieses Campus)',
    crossAreaSearchPersonDashboard: 'Lobby',
    crossAreaSearchPersonOutOfOffice: 'Abwesend',
    crossAreaSearchPersonNotFound: 'Es wurden keine Ergebnisse zum eingegebenen Suchbegriff gefunden.',

    // Room Actions
    enterRoomActionTitle: 'Raum betreten',
    knockOnDoorActionTitle: 'Anklopfen',
    editRoomActionTitle: 'Raum einrichten',
    sendMemoIntoRoomActionTitle: 'Nachricht in den Raum senden',
    roomSettingsActionTitle: 'Raum einrichten',
    createNewRoomActionTitle: 'Neuen Raum erstellen',
    createNewRoomActionLoadingTitle: 'Ein neuer Raum wird erstellt...',
    deleteRoomActionTitle: 'Raum archivieren',
    deleteRoomActionLoadingTitle: 'Archivieren...',
    deleteRoomActionConfirmationTitle: 'Raum ist archiviert.',
    NoRoomAvailableDescription: 'In diesem Bereich ist kein Raum verfügbar',
    memoPlaceholder: 'Geben Sie Ihre Nachricht ein...',
    mobileDescription1: 'Scannen Sie diesen Code mit Ihrem Handy',
    mobileDescription2: 'Um den Raum zu betreten',
    sendMemoToVisitor: 'Nachricht senden',
    sendHostMemo: 'Gastgeber eine Nachricht senden',

    // Room settings
    roomSettingsPanelTitle: 'Raum einrichten',
    roomNameInputLabel: 'Raumname',
    roomNameInputPlaceholder: 'Raum ohne Namen',
    iconPickerLabel: 'Raum-Symbol',
    privacySectionLabel: 'Datenschutz',
    openToVisitorsCheckBoxLabel: 'Für externe Besucher geöffnet',
    openToVisitorsCheckBoxDescription:
        'Besucher, die von CAMPUS-Mitgliedern eingeladen werden, können diesen Raum betreten. Dieser Raum wird mit diesem Symbol gesondert gekennzeichnet. Jedoch nur, wenn Besucher auf dem Campus sind.',
    confirmDeletePromptLabel: 'Sind Sie sicher, dass Sie diesen Raum aus dem CAMPUS entfernen möchten?',
    audioOnlyCheckBoxLabel: 'Video in diesem Raum deaktivieren',
    audioOnlyCheckBoxDescription: 'Gespräche Sind in diesem Raum nur ohne Videobild und nur auf der Tonspur möglich, wenn diese Option aktiviert ist',
    whitelistSelectorLabel: 'Raum-Zugangsberechtigung',
    whitelistSelectorPlaceholder: 'Tippen, um berechtigte Personen auszuwählen...',
    whitelistSelectorDescription: '',
    toggleWhitelistLabel: 'Zutritt nur für ausgewählte Benutzer zulassen',
    toggleWhitelistDescription: '',
    dismissAction: 'aufheben',
    deleteAction: 'löschen',
    noneAction: 'keine',
    deletionAction: 'löschen',
    updateAction: 'aktualisieren',
    deleteQuestion1: 'Sind Sie sicher?',
    deleteQuestion2: 'Nicht gespeicherte Änderungen verwerfen?',
    deleteQuestion3: 'Archivierte Räume können von keinem CAMPUS-Mitglied mehr betreten werden...',
    deleteQuestion4: 'Sie haben Änderungen an diesem Raum vorgenommen, die noch nicht gespeichert wurden... Wollen Sie diese verwerfen?',
    setTopicTitle: 'Thema festhalten',
    setATopicDialogBoxTitle: 'Beschreibe das Thema ',

    //Call view
    deviceSettingsActionTitle: 'Geräteeinstellungen',
    toggleVideoActionTitle: 'Kamera umschalten',
    toggleAudioActionTitle: 'Mikrofon umschalten',
    toggleAttachment: 'Dateien ein-/ausblenden',
    toggleLinkAttachment: 'Verlinkungen ein-/ausblenden',
    toggleToolAttachment: 'Werkzeuge ein-/ausblenden',
    safariNotSupported: 'Diese Funktion wird von Safari derzeit nicht unterstützt.',
    toggleTileViewActionTitle: 'Videobilder-Anordnung ändern',
    shareScreenActionTitle: 'Bildschirm teilen',
    shareScreenActionActiveTitle: 'Bildschirm nicht mehr teilen',
    toggleEncryptionActionTitle: 'Verschlüsselung umschalten (experimentell)',
    toggleEncryptionActionActiveTitle: 'Die Verschlüsselung ist aktiviert (experimentell)',
    raiseHandActionTitle: 'Hand heben',
    unraiseHandActionTitle: 'Tippen Sie auf "Fertig", um Ihre Hand zu senken.',
    unraiseHandActionButtonTitle: 'Fertig',
    toggleBackgroundDialogActionTitle: 'Meinen Videohintergrund festlegen',
    leaveRoomActionTitle: 'Zurück in den persönlichen Raum wechseln',
    toggleStatsActionTitle: 'Virtuellen Moderator ein-/ausblenden',
    encryptionIsEnabledLabel: 'Ende-zu-Ende-verschlüsselt',
    connectedToLabel1: 'Sicher verbunden mit der',
    connectedToLabel2: 'CAMPUS-Plattform',
    connectedToLabel3: 'Powered by IONOS Cloud ',
    personalRoomTitle: 's persönliches Büro',
    personalRoomHelper: 's persönliches',
    personalRoomTitleForNameEndingWithS: 's persönliches Büro',
    unknownPersonalRoomTitle: 'Ein persönliches Büro',
    callLoadingScreenLabel: 'Die Verbindung zu einem sicheren Server in Europa wird hergestellt...',
    callLoadingScreenDescription: 'Bitte warten Sie kurz, während eine Verbindung zu einem unserer sicheren Server in Europa herstellt wird.',
    changeCallAudioAndVideo: 'Hier können Sie Ihre Audio- und Videoeinstellungen ändern.',
    callRetryMessage: 'Wenn dies länger dauert als erwartet, versuchen Sie es bitte erneut.',
    PleaseStandByMessage: 'Bitte warten Sie.',
    announcingArrival: 'Wir kündigen Ihre Ankunft an...',
    retryActionTitle: 'Wiederholen',
    safariRoomCallDescription:
        'Safari verbietet standardmäßig das Cross-Site-Tracking, indem es Cookies von Drittanbietern und Cross-Site-LocalStorage deaktiviert. Sie können also leider nicht auf das Etherpad zugreifen, es sei denn, Sie deaktivieren die Einstellungen manuell, indem Sie die unten genannten Schritte ausführen.',
    safariRoomCallDescriptionStep1:
        '1. Öffnen Sie die Safari-Einstellungen, indem Sie auf das Menü "Safari" auf der linken Seite der Menüleiste und dann auf "Einstellungen" klicken, oder nutzen Sie die Tastenkombination `⌘,`.',
    safariRoomCallDescriptionStep2: '2. Wählen Sie die Registerkarte `Datenschutz`..',
    safariRoomCallDescriptionStep3: '3. Deaktivieren Sie das Kontrollkästchen "Cross-Site-Tracking verhindern".',
    waitingAreaTitle: 'Besucherempfang',
    videoCallTitle: 'Videogespräch',
    setATopicActionTitle: 'Thema festhalten',
    alertMessageWhileScreenShareIsActive: 'Bildschirmteilung beenden, um in Ihren persönlichen Raum zurückzugehen',
    callActionButtonSelectBackground: 'Hintergrund auswählen',

    // Device settings
    audioSettingsTitle: 'Audio-Einstellungen',
    videoSettingsTitle: 'Video-Einstellungen',
    audioInputDeviceTitle: 'Audio-Eingabegerät',
    audioOutputDevice: 'Audio-Ausgabegerät',
    videoDeviceTitle: 'Video-Gerät',
    selectDevicePlaceholder: 'Gerät auswählen',

    // Portal
    availableAreasTitle: 'Bereiche',
    manageAccessTitle: 'Mitglieder',
    campusSettingsTitle: 'CAMPUS Konfiguration',
    billingTitle: 'Billing',
    addAreaToTabBarActionTitle: 'Bereich zum Schnellwechsel in der Kopfzeile darstellen',
    removeAreaFromTabBarActionTitle: 'Bereichsdarstellung aus der Kopfzeile entfernen',
    changeLogTitle: 'Neuigkeiten',
    areaOpenToEveryoneLabel: 'Für alle Mitglieder zugänglich',

    // Members
    filterMembersPlaceholder: 'Mitgliedernamen filtern',
    emailColumnTitle: 'E-Mail',
    nameColumnTitle: 'Name',
    roleColumnTitle: 'Rolle',
    pendingInviteTitle: 'Registrierung noch ausstehend...',

    // Roles
    userRoleTitle: 'Mitglied',
    managerRoleTitle: 'Manager',
    userRoleTitleInCap: 'Mitglied',
    managerRoleTitleInCap: 'Manager',
    ownerRoleTitle: 'Eigentümer',
    inviteeRoleTitle: 'Eingeladen',
    inactiveInviteeRoleTitle: 'Inactive',

    // Language
    englishLanguageTitle: 'English',
    deutschLanguageTitle: 'Deutsch',

    //Alerts
    generalAlertTitle: 'Achtung',
    webSocketAlert: 'Wir können Sie nicht mit dem Web-Socket verbinden. Bitte versuchen Sie es erneut.',
    connectionTimedOut: 'Ihre Verbindung wurde unterbrochen.',
    safariDetection: 'Leider unterstützt CAMPUS derzeit den Safari-Browser nicht :/ Wir empfehlen die Verwendung von Edge oder Chrome',
    mobileDetection: 'Leider unterstützt CAMPUS im Moment keine mobile Ansicht :/ Wir empfehlen die Verwendung eines Computers',
    invalidDataAlert: 'Ungültige Daten',
    yeetAlert: 'Neu laden',
    browserNotSupportAlert: 'Dieser Browser unterstützt leider keine Desktop-Benachrichtigungen.',
    errorConnectingAlert: 'Es gab einen Verbindungsfehler... drücken Sie bitte "Ok", um die Verbindung wiederherzustellen.',
    connectionLostMessage: 'Verbindung abgebrochen!',
    lostConnectionMessage: 'Die Verbindung zum Internet scheint unterbrochen zu sein.',
    clickToReconnectMessage: 'Bitte klicken Sie auf die Schaltfläche unten, nachdem die Verbindung wiederhergestellt ist.',
    firefoxAlert: 'Firefox-Bildschirmfreigabe: Bitte klicken Sie zunächst einmal in den Videorahmen unten, bevor Sie versuchen, Ihren Bildschirm zu teilen.',
    reconnectToMicrosoft: 'Wiederherstellung der Verbindung zu Microsoft-Diensten... ',
    trialPeriodExpiredTitle: 'Testphase abgelaufen',
    trialPeriodExpiredContent: 'Die Campus-Testphase von [org] ist beendet.',
    trialPeriodExpiredContactSalesTeam1: 'Ihr Campus kann nun nicht mehr betreten werden? Bitte kontaktieren Sie jetzt unser Team unter ',
    trialPeriodExpiredContactSalesTeam2: ' das Ihnen gerne wieder Zugang zu Ihren Räumen und Bereichen verschafft.',
    trialPeriodExpiredContactSalesTeam3: 'Alternativ können Sie auch auf die Schaltfläche unten klicken und es wird Ihre Standard-E-Mail-Anwendung geöffnet.',
    trialPeriodExpiredUserContent:
        'Die Campus-Testphase für [org] ist beendet. Für Ihre Organisation wurde noch keine weiter Vereinbarung abgeschlossen. Bitte wenden Sie sich an den Vertrieb. Man hilft Ihnen dort gerne weiter.',
    trialPeriodExpiredChoiceTitle: 'Wählen Sie eine Aktion',
    trialPeriodExpiredChoiceAccept: 'Ein Abonnement erstellen',
    trialPeriodExpiredChoiceRefuse: 'Campus entfernen und eine neue Testphase starten',
    makeSubscriptionTitle: 'Ein Abonnement erstellen',
    makeSubscriptionContent: 'Um ein Abonnement abzuschließen, benötigen wir einige zusätzliche Angaben:',
    subscriptionFieldCompanyName: 'Name der Organisation',
    subscriptionFieldPostalCode: 'Postleitzahl',
    subscriptionFieldAddress: 'Adresse',
    subscriptionFieldAddressPlaceholder: 'Straße und Hausnummer',
    subscriptionFieldCityPlaceholder: 'Stadt',
    subscriptionFieldCity: 'Stadt',
    subscriptionFieldCountryCode: 'Länderkennzeichen',
    subscriptionFieldVatNumber: 'USt-IdNr.',
    trialPeriodAboutToExpireTitle: 'Die Testphase wird bald enden!',
    trialPeriodAboutToExpireDaysLeft: 'Es verbleiben noch [count] Tage bis zum Ende der Testphase, danach wird [org] entfernt.',
    trialPeriodAboutToExpireQuestion: 'Möchten Sie ihren Campus weiterhin nutzen? Dann setzen Sie sich jetzt bitte mit dem Vertrieb in Verbindung.',
    billingActiveDirectTitle: 'Nutzungsvertrag mit der ivicos GmbH',
    billingActiveDirectDescription: 'Dieser CAMPUS wird direkt mit der ivicos GmbH abgerechnet. Bitte wenden Sie sich bei Fragen an unser Team unter ',
    billingActiveDirectAlternative: 'Alternativ können Sie auf die Schaltfläche unten klicken und es wird Ihre Standard-E-Mail-Anwendung geöffnet.',

    // Tooltips
    announcementTitle: 'Senden Sie eine Nachricht an ALLE in diesem Bereich...',
    areaSwitchTitle: 'Zurück in die Lobby / Verfügbare Bereiche anzeigen',
    togglePanelTitle: 'Raumansicht ein- bzw. ausklappen',
    backToDashboardTitle: 'Zurück in die Lobby',
    openForVisitorsTitle: 'Dieser Raum ist für Besucher frei zugänglich',
    roomOptionsTitle: 'Aktionen',
    noAccessToRoom: 'Für diesen Raum braucht es eine spezielle Zugangsberechtigung',
    areaPresenceTooltip: {
        membersOnly: 'Derzeit {verb} in diesem Bereich {count} {members}',
        visitorsOnly: 'Derzeit {verb} in diesem Bereich {count} {visitors}',
        bothPresent: 'Derzeit {verb} in diesem Bereich {memberCount} {members} und {visitorCount} {visitors}',
        member: 'Mitglied',
        members: 'Mitglieder',
        visitor: 'Besucher',
        visitors: 'Besucher',
        is: 'ist',
        are: 'sind'
    },

    // Attachments
    toggleAttachmentsActionTitle: 'Dateien ein-/ausblenden',
    attachmentPanelTitleLinks: 'Verlinkungen',
    attachmentPanelTitleTools: 'Werkzeuge',
    videoOwnerTransferModalTitle: 'Video Playback Control',
    videoOwnerTransferModalSentence1: 'You are about to transfer control of video playback to',
    videoOwnerTransferModalSentence2: 'Are you sure you want to continue?',
    videoOwnerTransferModalCancelButtonLabel: 'Cancel',
    videoOwnerTransferModalTransferButtonLabel: 'Transfer',
    videoOwnershipTransferredToLocalUserModalSentence1Part1: 'You have been elected controller of the video by ',
    videoOwnershipTransferredToLocalUserModalSentence1Part2: ' and are now responsible for its playback. ',
    videoOwnershipTransferredToLocalUserModalSentence2: 'If you leave the room for any other reason, you can appoint another person to control video playback.',
    videoOwnershipTransferredToLocalUserModalOkButtonLabel: 'Ok',
    videoControlPanelTitle: 'Video Playing',
    videoControlPanelPlaybackControlledByTitle: 'Gesteuert von',
    videoControlPanelTransferPlaybackControlTitle: 'Übertragung der Videosteuerungswiedergabe auf',
    pinnedAttachmentPanelTitle: 'Angeheftetes Video',
    createNewAttachmentActionTitle: 'Neue Datei anhängen',
    filterAttachmentsPlaceholder: 'Inhalte filtern...',
    savedItemTitle: 'Anhänge',
    noAttachmentsWarning: 'Diesem Raum wurden noch keine Dateien zugeordnet.',
    noAttachmentsHelperText: 'In diesem Raum geteilte Dateien werden hier angezeigt',
    chooseAttachmentTypeTitle: 'Dateitypen...',
    createLinkAttachmentTitle: 'Neue Verlinkung erstellen',
    createToolAttachmentTitle: 'Neues Werkzeug nutzen',
    linkTypeTitle: 'Internet-Verknüfung',
    collaboardTypeTitle: 'Collaboard',
    collaboardTypeDescription: 'Gemeinsam auf Collaboard skizzieren',
    collaboardLinkAttachmentModalBoxTitle: 'Neuen Collaboard Link-Anhang erstellen',
    colleboardLinkAttachmentModalBoxSubText: 'Bitte geben Sie einen Link zu einer Collaboard Project ein (oder fügen Sie ihn ein)',
    conceptboardTypeTitle: 'Conceptboard',
    conceptboardTypeDescription: 'Gemeinsam auf Conceptboard skizzieren',
    conceptboardLinkAttachmentModalBoxTitle: 'Neuen Conceptboard Link-Anhang erstellen',
    conceptboardLinkAttachmentModalBoxSubText: 'Bitte geben Sie einen Link zu einer Conceptboard Project ein (oder fügen Sie ihn ein)',
    conceptboardLinkAttachmentCreateNewText: 'Neuen Conceptboard erstellen',
    conceptboardLinkAttachmentAddExistingText: 'Vorhandenen Conceptboard Link hinzufügen',
    conceptboardSaveButtonCreate: 'Erstellen',
    conceptboardSaveButtonSaveToList: 'Zur Liste hinzufügen',
    etherpadTypeTitle: 'Etherpad',
    youtubeLinkTypeTitle: 'YouTube',
    youtubeLinkTypeDescription: 'Gemeinsam ein Video ansehen',
    tldrawTypeTitle: 'Tldraw',
    linkTypeDescription: 'Verknüpfung zu Webseite/Werkzeug/Datei erstellen',
    etherpadTypeDescription: 'Gemeinsam, synchron Text bearbeiten',
    tldrawTypeDescription: 'Gemeinsam auf Flipchart skizzieren',
    enterUrlActionTitle: 'Bitte hier Internet-Adresse (inklusive https://) einfügen',
    deleteAttachmentConfirmationTitle: 'Sind Sie sicher, dass Sie diese Verknüpfung löschen möchten?',
    editAttachmentTitle: 'Dateibeschreibung bearbeiten',
    noDescriptionProvidedWarning: 'Keine Beschreibung vorhanden',
    createdAtTitle: 'Erstellt:',
    justNowTitle: 'gerade eben',
    oneMinutePassedTitle: 'vor einer Minute',
    minutesPassedTitle: 'vor {quantity} Minuten',
    oneHourPassedTitle: 'vor einer Stunde',
    hoursPassedTitle: 'vor {quantity} Stunden',
    yesterdayTitle: 'gestern',
    daysPassedTitle: 'vor {quantity} Tagen',
    weeksPassedTitle: 'vor {quantity} Wochen',
    monthsPassedTitle: 'vor {quantity} Monaten',
    aYearPassedTitle: 'vor einem Jahr',
    yearsPassedTitle: 'vor {quantity} Jahren',
    giveAttachmentNameTitle: 'Geben Sie der Datei einen Titel',
    giveAttachmentDescriptionTitle: 'Fügen Sie eine Beschreibung zur Datei hinzu',
    linkAttachmentModalBoxTitle: 'Neuen Link-Anhang erstellen',
    linkAttachmentModalBoxSubText:
        'Bitte geben Sie einen Link zu einer Webseite ein (oder fügen Sie ihn ein), die in einem neuen Browser-Tab geöffnet werden kann',
    youtubeLinkAttachmentModalBoxTitle: 'Erstellung eines neuen Videoanhangs',
    youtubeLinkAttachmentModalBoxSubText: 'Fügen Sie unten den Link zu einem beliebigen Video ein',
    youtubeLinkAttachmentModalVideoPinText: 'Video an den Raum anheften',
    youtubeLinkAttachmentModalVideoPinUpperText: 'Das Video kann an den Raum angeheftet werden, so dass es im oberen Bereich des Dateifensters angezeigt wird.',
    youtubeVideoPlaying: 'Video Wiedergabe',
    youtubePlaybackControl: 'Gesteuert von',
    youtubePlaybackTransfer: 'Übertragung der Videosteuerungswiedergabe an',
    youtubePinnedVideo: 'Angeheftetes Video',

    // Speaker stats
    speakerStatsTitle: 'Virtueller Moderator',
    totalTalkTimeTitle: 'Gesprächszeit insgesamt',
    personalTalkTimeToggle: 'Einblenden meiner persönliche Sprechzeit.',
    talkingTooMuchToggle: 'Informiere nur mich, wenn ich zu viel rede.',
    experimentalLabelTitle: 'Experimentell',
    noDataTitle: 'Bislang keine Daten vorhanden',
    talkingMoreDescription: 'Hinweis: Sie reden aktuell deutlich mehr als alle anderen.',
    talkingMoreDescription2: 'Wäre es nun an der Zeit, jemand anderem das Wort zu erteilen?',
    startButtonLabel: 'Start',
    roundTableTitle: 'Gesprächsrunde',
    applyTimer: 'Sprechzeit definieren',
    startRoundTableModeTitle: 'Starte die Gesprächsrunde',
    stopRoundTableModeTitle: 'Beende die Gesprächsrunde',
    roundTableModeDialogBoxTitle: 'Gesprächsrunden-Modus',
    youAreOnTitle: 'Sie sind dran!',
    youAreTheLastSpeakerTitle: 'Sie beenden die Gesprächsrunde',
    clickNextWhenYouAreDoneTitle: 'Bitte "Nächster" anklicken, wenn Sie fertig sind',
    nextActionTitle: 'Nächster',
    nextActionTitle2: 'Weiter',
    isOnTitle: 'ist dran!',
    minutesLabel: 'Minuten',
    addUserToRoundTableButtonLabel: 'Hinzufügen',
    removeUserFromRoundTableButtonLabel: 'Entfernen',

    // General Time Words
    from: 'Von',
    at: 'Am',
    to: 'bis',
    until: 'bis',
    since: 'seit',
    everyWeekOn: 'Jede Woche',
    everyday: 'Jeden Tag',
    weekly: 'Wöchentlich',
    daily: 'Täglich',
    noRepeat: 'Keine Wiederholung',

    // Months
    january: 'Januar',
    february: 'Februar',
    march: 'März',
    april: 'April',
    may: 'Mai',
    june: 'Juni',
    july: 'Juli',
    august: 'August',
    september: 'September',
    october: 'Oktober',
    november: 'November',
    december: 'Dezember',

    // MonthsInShortForm
    jan: 'Jan',
    feb: 'Feb',
    mar: 'Mär',
    apr: 'Apr',
    may2: 'Mai',
    jun: 'Jun',
    jul: 'Jul',
    aug: 'Aug',
    sep: 'Sep',
    oct: 'Okt',
    nov: 'Nov',
    dec: 'Dez',

    // Weekdays
    monday: 'Montags',
    tuesday: 'Dienstags',
    wednesday: 'Mittwochs',
    thursday: 'Donnerstags',
    friday: 'Freitags',
    saturday: 'Samstags',
    sunday: 'Sonntags',

    // ImagePicker
    uploadNewImageTitle: 'Ein neues Bild hochladen',
    uploadNewImageActionTitle: 'Neues Bild hochladen',
    recentlyUploadedImages: 'Kürzlich hochgeladene Bilder',
    uploadActionTitle: 'Hochladen',
    clickToUploadImage: 'Zum Hochladen eines Bildes hier klicken',
    deleteImageDescription: 'Sind Sie sicher, dass Sie dieses Bild löschen möchten?',
    imageTitle: 'Bild',
    uploadCap: 'Die Größe des Bildes darf 2 Megabytes nicht überschreiten',
    uploadCapError: 'Die Größe des Bildes, das Sie hochladen möchten, ist größer als 2 Megabytes',
    onImagePickerModalClose: 'Bestätigen und schließen',

    // OverlaySelector
    videoOverlayLabel: 'Video-Overlay',
    overlayLabel: 'Overlay',
    backgroundLabel: 'Hintergrund',
    checkboxLabel: 'Transparenz des Bildes verwenden',

    // RegistrationForm
    registrationFormLabel: 'Zugang zum CAMPUS',
    registrationFormPlaceholder: 'Bitte geben Sie hier Ihren Namen ein',
    registrationFormErrorMessage: 'Bitte geben Sie einen gültigen Namen ein',
    registrationFormInfoMessage:
        'Bitte geben Sie Ihren Namen, einen Spitznamen oder Psydonym ein. Diese Information wird nicht in unserem System gespeichert und gelöscht, sobald Sie den CAMPUS verlassen.',

    // User Profile
    editNamePlaceholder: 'Geben Sie Ihren Namen ein',
    editNameErrorMessage: 'Die Mindestzeichenanzahl beträgt ein Zeichen',
    updateImageButtonLabel: 'Bild aktualisieren',
    editNameButtonLabel: 'Namen editieren',

    // OnboardingVideo
    onboardingVideoTitle: 'Dieses kurze Video erklärt Ihnen die wichtigsten Funktionen des CAMPUS. ',

    // FlagsView
    goBackActionTitle: 'Zurück wechseln',
    darkModeActionTitle: 'Dunklen Anzeigemodus einschalten',
    enableThisFrag1: 'Wenn Sie diese Option aktivieren, können Sie den CAMPUS im Dunkel-Modus verwenden.',
    useJitsiEnv: 'Verwenden der Jitsi-Staging-Umgebung',
    enableThisFrag2: 'Wichtig: Wenn Sie diese Funktion aktivieren, können Sie nicht mit Benutzern sprechen, die diese Funktion nicht aktiviert haben.',
    useTestActivityTimersTitle: 'Test-Aktivitäts-Timer verwenden',
    useTestActivityTimersDescription:
        'Verkürzt alle Inaktivitäts-, Away-, Lobby- und Mitternacht-Timer zum schnellen Testen. Die Seite wird beim Umschalten neu geladen. Danach wieder deaktivieren.',
    useMatrixChatTitle: 'Matrix-Chat aktivieren',
    useMatrixChatDescription:
        'Der Matrix-Chat befindet sich noch in Entwicklung und ist außerhalb der Beta-Umgebung deaktiviert. Beim Aktivieren wird eine Verbindung zum Chat-Server hergestellt und das Chat-Widget auf Ihrem persönlichen Dashboard angezeigt. Die Seite wird beim Umschalten neu geladen.',

    // App Errors
    logInTwiceTitle: 'Sie haben sich zweimal in denselben Bereich eingeloggt, es gibt sie jedoch nur einmal.',
    logInTwiceDescription:
        'Sie wurden auf dieser Browser-Registerkarte automatisch abgemeldet, weil Sie sich von einem anderen Ort aus, im selben Bereich angemeldet haben. Sie können sich nur von einer Browser-Registerkarte aus mit demselben Konto in denselben Bereich anmelden.',
    sessionExpiredTitle: 'Ihre Sitzung ist abgelaufen. Sie wurden automatisch abgemeldet.',
    sessionExpiredDescription: 'Sie wurden aus Sicherheitsgründen automatisch abgemeldet.',
    sessionExpiredReasonTitle: 'Hier einige Gründe, warum dies passieren kann:',
    sessionExpiredReason1:
        'Ihr ‘Magic-Link’ war bereits längere Zeit gültig und ist nun aus Sicherheitsgründen abgelaufen. Eine neue Anmeldung ist erforderlich.',
    sessionExpiredReason2:
        'Sie haben versucht, ein Lesezeichen zu verwenden, um einen persönlichen Raum zu betreten. Dies ist aus Sicherheitsgründen nicht erlaubt.',
    sessionExpiredReason3: 'Sie haben den Campus möglicherweise von einem anderen Gerät aus betreten.',
    sessionExpiredReconnect: 'Verbindung wiederherstellen',
    resourceNotFoundTitle: 'Der von Ihnen angeforderte Zugang konnte nicht gefunden werden',
    resourceNotFoundDescription: 'Sie wurden automatisch abgemeldet',
    unexpectedErrorOccuredTitle: 'Es ist ein unerwarteter Fehler aufgetreten',
    unexpectedErrorOccuredDescription:
        'Ihre Verbindung wurde automatisch unterbrochen, weil ein unerwarteter Fehler aufgetreten ist. Bitte kontaktieren Sie Ihren Campus-Betreiber oder info@ivicos.eu',

    // loadingStrings
    loadingStringAreas: 'Bereiche laden...',
    loadingStringSettings: 'Einstellungen laden...',
    loadingStringMembersList: 'Mitgliederliste laden',
    loadingStringInvitation: 'Einladungen laden...',
    loadingStringWaitingAreas: 'Wartebereich betreten',
    loadingStringBilling: 'Billing laden...',
    loadingStringFindCampusFetchingOrgs: 'CAMPUS betreten...',
    loadingStringCoreInitializing: 'Laden... Bitte warten...',
    loadingStringCoreRoom: 'In den Raum eintreten...',
    loadingStringCoreArea: 'Prüfe die verfügbaren Räume...',
    loadingStringCoreDashboardLobby: 'In die CAMPUS-Lobby eintreten...',
    loadingStringCoreDashboardMembers: 'Mitgliederliste laden',
    loadingStringCoreDashboardSettings: 'Zu den CAMPUS-Einstellungen wechseln',
    loadingStringCoreDashboardBilling: 'Prüfe die Daten...',
    loadingStringCoreDashboardChangelog: 'Aktualisiere die Liste',
    loadingStringSubAreas: 'Sich auf dem CAMPUS bewegen',
    loadingStringVisitorExit: 'Ihr Besuch wird beendet—bitte kurz warten...',
    loadingStringHostPerspectiveWaitingArea: 'In den CAMPUS-Besucherempfang eintreten...',

    // SetupAssistant
    setProfileImage: 'Profilfoto festlegen',
    setOrgLogo: 'Unternehmenslogo einsetzen',
    setOrgColor: 'Unternehmensfarbe festlegen',
    SetupAssistantLabelOpenPrimary: 'Bitte das Unternehmensprofil vervollständigen!',
    SetupAssistantLabelOpenSecondary: 'Es gibt noch ein paar Dinge, die Sie als CAMPUS-Manager erledigen müssen, bevor Ihr CAMPUS einsatzbereit ist!',
    SetupAssistantLabelCompletedPrimary: 'Vorbereitungen abgeschlossen!',
    SetupAssistantLabelCompletedSecondary: 'Sie haben Ihr Unternehmensprofil vollständig eingerichtet!',
    completeLabel: 'erledigt',
    completedLabel: 'abgeschlossen',
    openLabel: 'noch offen',

    // OnboardingVideo
    introVideoTitle: 'Kurzes Einführungsvideo',
    tutorialConfirmationTitle: 'Ein paar Tipps, um sich in Ihrem neuen Büro zu orientieren!',

    // Intro Steps
    areaIntroStep1: 'Willkommen zu dieser kurzen Einführung in Ihren CAMPUS! Klicken Sie einfach auf "Weiter", um loszulegen. ',
    areaIntroStep2:
        'Hier sind Registerkarten, um zwischen Bereichen zu wechseln und Hinweise auf Neuerungen zu erhalten. Für CAMPUS-Manager gibt es zusätzlich die Registerkarten "Mitglieder verwalten" und "Campus-Einstellungen".',
    areaIntroStep3: 'Dies ist ein Bereich. Innerhalb von Bereichen können Sie Räume erstellen. Es kann mehrere Bereiche auf dem CAMPUS geben.',
    campusSettingIntroStep1: 'Hier können Sie Ihr Profilbild hinterlegen und individuelle Einstellungen vornehmen.',
    campusSettingIntroStep2: 'Hier können Sie den CAMPUS-Namen, die Unternehmensfarbe und das Unternehmens-Logo festlegen.',
    memberIntroStep1:
        'CAMPUS-Manager können hier Personen zum CAMPUS einladen, indem Sie deren E-Mail eingeben und auf die Schaltfläche “Einladung versenden” klicken. In der Tabelle unten können Sie Einladungen stornieren, erneut senden sowie Mitglieder wieder entfernen.',
    memberIntroStep2:
        'Diese Tabelle zeigt alle Personen, die Sie zu Ihrem CAMPUS eingeladen haben, unabhängig davon, ob sie die Einladung angenommen haben oder nicht. Name und ggf. Profilbild werden angezeigt, sobald die Einladung angenommen wurde.',
    memberIntroStep3: 'E-Mail-Daten in der Tabelle suchen.',
    roomIntroStep1:
        'Hier finden Sie alle Informationen zu Ihrem Profil bei CAMPUS. Sie können ein persönliches Profilbild hinterlegen und Präferenzen einstellen.',
    roomIntroStep2:
        'Jedes Mitglied hat einen eigenen persönlichen Raum, sobald die Person einen Bereich betritt. Bewegen Sie den Mauszeiger über Profilbider, um weitere Kommunikationsmöglichkeiten anzuzeigen.',
    roomIntroStep3:
        'Räume sind für verschieden Funktionen gestaltbar, z.B. für Besprechungen, Workshops oder gemeinsamen Arbeiten/Lernen. Sie sind flexibler gestaltbar als physische Räume und können nach Belieben gelöscht bzw. archiviert werden.',
    roomIntroStep4: 'Hier können Sie Besucher einladen, die nicht Mitglieder des CAMPUS sind.',
    roomIntroStep5: 'Mit diesen Icons können Sie u.a. die Video- und Anrufeinstellungen anpassen.',
    roomIntroStep6: 'Mit diesen Icons können Sie weitere nützliche CAMPUS-Funktionen erreichen, z. B. den "Virtuellen Moderator".',
    roomIntroStep7: 'Hier endet das kurze Tutorial. Viel Spaß beim Entdecken ihres CAMPUS!',

    // Not Supported Browser warning
    notSupportedBrowserString1: 'ist eine Browseranwendung, für die keine Software installiert werden muss.',
    notSupportedBrowserString2:
        'Da /devices/ und /devices/ häufig aktualisiert werden und manchmal Inkompatibilitäten verursachen, können nicht alle Versionen unterstützt werden.',
    notSupportedBrowserString3:
        'Wir bitten um Verständnis, dass ivCAMPUS nicht mit den /browser/ und /browser/Versionen von /browser/ und /browser/ genutzt werden kann.',
    notSupportedBrowserString4: 'Bitte verwenden Sie einen der folgenden Browser:',
    notSupportedBrowserFooterText: 'Für weitere Informationen über den ivCAMPUS finden Sie auf /unsere Website / oder kontaktieren Sie uns /hier',
    downloadHere: 'Herunterladen',

    // SetupCompletePage
    setupCompletePageTitle: 'CAMPUS einrichten!',

    // Profile page
    profilePageTitle: 'Nutzerprofil einrichten',
    profilePageTextFieldPlaceholder: 'Geben Sie Ihren vollständigen Namen ein',

    // ivCAMPUS Setup page
    ivCAMPUSSetupPageTitle: 'CAMPUS Einrichtung',
    nameLabel: 'Name',
    organisationNamePlaceholder: 'Unternehmensname',
    sizeOfTheOrganisationLabel: 'Mitarbeiterzahl der Organisation',
    sizeOfTheOrganisationPlaceholder: '',
    locationsLabel: 'Standortanzahl der Organisation',
    howManyLocationsPlaceholder: '',
    ivCAMPUSSetupPageCheckBoxDescription1: 'Ich bestätige hiermit, dass ich den CAMPUS für',
    ivCAMPUSSetupPageCheckBoxDescription3: ' einrichte',
    ivCAMPUSSetupPageCheckBoxDescription2: 'Hiermit bestätige ich, dass ich berechtigt bin einen CAMPUS einzurichten - und zwar für (die Organisation)',
    moreThan500: 'mehr als 500',
    moreThan20: 'mehr als 20',
    enterOrgNameErrorMessage: 'Bitte geben Sie einen gültigen Unternehmensnamen ein',
    enterOrgSizeErrorMessage: 'Bitte wählen Sie die etwaige Unternehmensgröße',
    enterOrgLocationErrorMessage: 'Bitte geben Sie die ungefähre Anzahl von Standorten an',

    // FindCampus page
    findCampusPageTitle: 'Bei nachfolgender Organisation anmelden...',
    findCampusPageLabel: 'Wechseln zu:',
    findCampusPagePlaceholder: 'CAMPUS auswählen',
    findCampusHintTitle: 'Nützlicher Hinweis...',
    findCampusHintDescription1: 'Öffnen Sie ivCAMPUS in den nächsten Tagen einfach in Ihrem üblichen Browser: ',
    findCampusHintLink: 'https://ivicos-campus.app',
    findCampusHintDescription2: 'Nach 7 Tagen senden Sie sich einfach einen neuen Magic Link.',
    hideOption: 'Optionen ausblenden',
    showOption: 'Weitere Optionen einblenden',
    startSetupButtonTitle: 'Neuen CAMPUS erstellen...',
    startSetupButtonDescription: 'Neue Organisation erstellen',
    seeAllInvitations: 'Alle Einladungen anzeigen',
    invitationTitle: 'Sie erhalten als Mitglied Zugang zu ',
    noSponsorModalTitle: 'Zugang inaktiv',
    noSponsorModalWelcome: 'Willkommen auf dem ivCAMPUS.',
    noSponsorModalDescription: 'Sie haben jetzt die Möglichkeit sich von der Leistungsstärke von Campus zu überzeugen. ',
    noSponsorModalTip: 'Die verbleibende Zeit ihres Testzeitraums können Sie sich nach der Registierung im Tab “Billing” anzeigen lassen.',
    trialPeriodOverButConsider1: 'Ihr Testzeitraum ist abgelaufen.',
    trialPeriodOverButConsider2: 'Sie können jedoch fortfahren. Hierfür bitte den…',
    createNewBuildingDescriptions: {
        description1: 'Bitte seien Sie sich über die Auswirkungen dieser Aktion im Klaren. Sie werden einen neuen Ort erstellen.',
        description2: 'In dieses Gebäude gilt es Mitglieder einzuladen und dieses neue Gebäude sowie Räume zu verwalten.',
        description3: 'Dies ist beispielsweise nützlich, um die Zusammenarbeit verschiedener Organisationen zu vereinfachen.'
    },

    // General Button Text
    enter: 'Eintreten',
    login: 'Anmelden',
    accept: 'Annehmen',
    decline: 'Ablehnen',
    acceptAndJoin: 'Annehmen & Zutritt erhalten',
    loading: 'Laden...',
    somethingWentWrong: 'Etwas ging leider schief',
    continue: 'Weiter',
    finish: 'Fertig',
    okAction: 'Ok',

    // General Text
    here: 'hier',
    orVisitOur: 'oder besuchen Sie unsere',
    helpPage: 'Hilfeseiten',
    empty: 'Leer',
    signedInAs: 'Eingeloggt als ',
    errorHasOccured: 'Es it ein Fehler aufgetreten',
    talkingToMicrosoft: 'Mit der Microsoft Identity Platform verbinden...',
    settingUpYourCampus: 'CAMPUS einrichten...',

    // Error messages
    min3: 'Der Name sollte mindestens 3 Zeichen lang sein',
    max7: 'Der Name darf maximal 72 Zeichen lang sein',
    minimumLimit: 'Die Mindestanzahl beträgt drei Zeichen',

    // Login Page
    signInTitle: 'Anmelden',
    emailPlaceHolder: 'Geben Sie Ihre Arbeits-E-Mail-Adresse ein',
    emailButtonText: 'Magic-Link erhalten',
    emailErrorMessage: 'Bitte geben Sie eine gültige Email-Adresse ein!',
    loginPageDescription3: 'Wir senden Ihnen einen Zugangslink an Ihre E-Mail-Adresse.',
    orOptionTitle: 'oder',
    developedByTitle1: 'Entwickelt von ',
    developedByTitle2: '(c) ivicos GmbH, Deutschland',
    newToPassWordlessAcesss: 'Ein passwortloser Zugang ist neu für Sie?',
    clickHereToKnowMore: 'Klicken Sie hier, um mehr zu erfahren.',
    newSince: 'Neu, seit 03/2025',
    toReceiveTheMagicLinkPleaseEnterTheCodeBelowPart1: 'Um den Magic-Link zu erhalten,',
    toReceiveTheMagicLinkPleaseEnterTheCodeBelowPart2: ' bitte geben Sie den Code unten ein',
    toReceiveTheMagicLinkPleaseEnterTheCodeBelowPart3: 'Code eingeben',
    toReceiveTheMagicLinkPleaseEnterTheCodeBelowPart4: 'Überprüfen',
    toReceiveTheMagicLinkPleaseEnterTheCodeBelowPart5: 'Bitte überprüfen Sie, ob der Code korrekt ist und die Groß-/Kleinschreibung beachtet wurde.',

    // NewUserAwaitingConfirmation Page
    userConfirmationPageTitle: 'Sie erhalten per E-Mail einen Magic-Link, um Ihnen Zugang zum CAMPUS zu gewähren.',
    userConfirmationPageDescription1: 'Bitte zum E-Mail-Posteingang (ggf. Spam-Ordner) wechseln.',
    userConfirmationPageDescription3:
        'Klicken Sie bitte auf die Schaltfläche oder kopieren Sie den Magic-Link und fügen Sie ihn in diesen oder einen anderen Browser-Tab ein.',
    userConfirmationPageDescription4: 'Keine E-Mail innerhalb von wenigen Minuten erhalten?',
    userConfirmationPageDescription5: 'Geben Sie bitte',
    userConfirmationPageDescription6: 'Ihre E-Mail-Adresse erneut ein, damit ein anderes System nochmal den Magic-Link verschickt.',

    // MagicLinkVerification
    processingLoadingText: 'Überprüfung...',

    // NewUserAccessGranted
    accessGrantedTitle: 'Zugang gewährt!',
    accessGrantedDescription1: ' wurde bestätigt.',
    accessGrantedDescription2: 'Bitte klicken Sie erneut',
    accessGrantedDescription3: 'wenn Sie nicht automatisch zum CAMPUS weitergeleitet werden.',

    // UserAccessGranted
    userAccessGrantedDescription1: 'Hallo ',
    userAccessGrantedDescription2: '! Ihr Zugang wurde bestätigt.',
    userAccessGrantedDescription3: 'wenn Sie nicht automatisch zu CAMPUS weitergeleitet werden.',

    // NewUserSomethingWrong
    somethingWrongTitle: 'Etwas ist schief gegangen!',
    newUserSomethingWrongDescription1: 'Während der Authentifizierung ist ein Fehler aufgetreten.',
    newUserSomethingWrongDescription2: 'Um einen neuen Zugangslink zu erhalten, klicken Sie bitte',
    newUserSomethingWrongDescription3: 'Wenn der Fehler weiterhin auftritt, kontaktieren Sie bitte den Support',

    // AccountCreationSuccessful
    accountCreationSuccessfulTitle1: 'Einen CAMPUS-Zugang für ',
    accountCreationSuccessfulTitle2: ' wurde erfolgreich erstellt!',
    accountCreationSuccessfulDescription:
        'Bitte prüfen Sie Ihren E-Mail-Posteingang (auch Ihren Spam-Ordner) und klicken Sie auf den Zugangslink, um dann Ihr Profil zu vervollständigen.',

    // AccountCreationSomethingWentWrong
    accountCreationSomethingWentWrongDescription1: 'Die Erstellung eines neuen Kontos konnte nicht abgeschlossen werden.',
    accountCreationSomethingWentWrongDescription2: 'Bitte kontaktieren Sie den Support.',

    // LoadingStrings
    creatingAnAccountLoadingString: 'Zugang wird erstellt...',
    creatingAccountAwaitingServerLoadingString: 'Warten auf Bestätigung...',

    // PasswordlessAccessModal;
    passwordLessAccessModalTitle: 'Warum ein passwortloser Zugang?',
    passwordLessAccessModalDescription1:
        'Diese Methode erlaubt die Überprüfung der Identität eines Benutzers ohne Verwendung von Passwörtern und bietet so unmittelbaren Schutz vor den gefährlichsten und häufigsten Cyberangriffen.',
    passwordLessAccessModalDescription2:
        'Auf diese Weise sind Benutzer vor betrügerischen E-Mails und Textnachrichten geschützt, mit denen versucht wird, an Passwörter zu gelangen. Da nirgendwo ein Passwort gespeichert wird, kann es auch nicht gestohlen werden.',
    passwordLessAccessModalDescription3: 'Wie funktioniert das dann?',
    passwordLessAccessModalDescription4:
        'Die Methode ist einfach. Die Nutzer geben lediglich ihre E-Mail-Adresse in ein Anmeldefeld ein. Anstatt dann nach einem Passwort gefragt zu werden, erhalten sie eine E-Mail mit einem Link zum anklicken, um Zugang zu erhalten. Aus Sicherheitsgründen wird jeweils ein anderer Link bei jedem Anmeldeversuch an die Nutzer verschickt.',
    passwordLessAccessModalDescription5:
        'Früher ging man zur Arbeit und zeigte dem Pförtner seinen Mitarbeiterausweis. Heute funktioniert es mit einem einfachen Link, mit dem man dann den ganzen Arbeitstag auf dem CAMPUS präsent ist.',

    integrationsTitle: 'Integrationen',

    // OUTLOOK WIDGET
    outlookWidgetConnectTitle: 'Mails',
    outlookWidgetConnectDescription: 'Verbinde dein Outlook-Konto, um deinen Posteingang hier zu sehen.',
    outlookWidgetConnectButton: 'Outlook verbinden',
    outlookWidgetDisconnectLink: 'Trennen',
    outlookWidgetInboxTitle: 'Posteingang',
    outlookWidgetComposeButton: 'Neue E-Mail',
    outlookWidgetEmptyInbox: 'Keine Nachrichten im Posteingang.',
    outlookWidgetErrorMessage: 'Etwas ist schiefgelaufen.',
    outlookWidgetRetryButton: 'Erneut versuchen',
    outlookWidgetReplyButton: 'Antworten',
    outlookWidgetReplyAllButton: 'Allen antworten',
    outlookWidgetDeleteButton: 'Löschen',
    outlookWidgetSendButton: 'Senden',
    outlookWidgetCancelButton: 'Abbrechen',
    outlookWidgetToLabel: 'An',
    outlookWidgetSubjectLabel: 'Betreff',
    outlookWidgetBodyLabel: 'Nachricht',
    outlookWidgetSendFailed: 'Senden fehlgeschlagen. Bitte erneut versuchen.',
    outlookWidgetDeleteFailed: 'Löschen fehlgeschlagen. Bitte erneut versuchen.',
    outlookWidgetAccountSettingsTitle: 'Konto',
    outlookWidgetAccountSectionTitle: 'Verbundenes Konto',
    outlookWidgetBackButton: 'Zurück',
    outlookWidgetAttachButton: 'Datei anhängen',
    outlookWidgetAttachSizeError: 'Eine oder mehrere Dateien überschreiten 3 MB. Bitte verwenden Sie Outlook für große Anhänge.',
    outlookWidgetAttachSizeHint: 'Anhänge über 3 MB können nur direkt über Microsoft Outlook gesendet werden.',
    outlookWidgetOpenInOutlook: 'In Microsoft Outlook öffnen',
    // ZAMMAD WIDGET
    zammadWidgetTitle: 'Zammad-Tickets',
    zammadWidgetCategoryLabel: 'Kategorie',
    zammadWidgetColumnPickerTitle: 'Spalten',
    zammadWidgetNoColumnsSelected: 'Keine Spalten ausgewählt',
    zammadWidgetEmptyState: 'Keine Tickets in dieser Kategorie.',
    zammadWidgetErrorMessage: 'Etwas ist schiefgelaufen.',
    zammadWidgetUnreachableTitle: 'Zammad-Server nicht erreichbar',
    zammadWidgetUnreachableDescription:
        'Prüfen Sie, ob Sie mit dem Netzwerk Ihrer Organisation oder dem VPN verbunden sind. Möglicherweise antwortet der Zammad-Server auch nicht.',
    zammadWidgetBaseUrlError: 'Die Zammad-Adresse dieser Organisation scheint nicht korrekt zu sein. Bitte prüfen Sie sie in den Campus-Einstellungen.',
    zammadWidgetRetryButton: 'Erneut versuchen',
    zammadWidgetConnectTitle: 'Zammad-Konto verbinden',
    zammadWidgetConnectDescription: 'Verbinden Sie Ihr Zammad-Konto, um hier Ihre Tickets zu sehen.',
    zammadWidgetDisconnectedHeading: 'Widget mit Zammad verknüpfen',
    zammadWidgetConnectBackDescription: 'Erstellen Sie in Zammad einen API-Token und fügen Sie diesen hier ein.',
    zammadWidgetConnectBaseUrlLabel: 'Base URL',
    zammadWidgetConnectTokenLabel: 'Ihr API-Token',
    zammadWidgetConnectButton: 'Verbinden',
    zammadWidgetDisconnectButton: 'Zammad-Konto trennen',
    zammadWidgetDisconnectConfirmTitle: 'Zammad trennen?',
    zammadWidgetDisconnectConfirmWarning: 'Sie sehen hier keine Tickets mehr, bis Sie sich erneut verbinden.',
    zammadWidgetHelpResourcesLabel: 'Hilfe & Ressourcen',
    zammadWidgetGenerateTokenLabel: 'Hilfe zur Zammad API-Token-Erstellung',
    zammadWidgetGenerateTokenText: 'Jetzt einen API-Token in Zammad erstellen',
    zammadWidgetGuideLinkLabel: 'Anleitung',
    zammadWidgetGuideLinkText: 'Hilfe zur Zammad API-Token-Erstellung',
    zammadAttributeNumber: '#',
    zammadAttributeTitle: 'Titel',
    zammadAttributeCustomer: 'Kunde',
    zammadAttributeOrganization: 'Organisation',
    zammadAttributeGroup: 'Gruppe',
    zammadAttributeOwner: 'Besitzer',
    zammadAttributeState: 'Status',
    zammadAttributePendingTime: 'Warten bis',
    zammadAttributePriority: 'Priorität',
    zammadAttributeArticleCount: 'Artikel#',
    zammadAttributeTimeUnit: 'Erfasste Zeiten',
    zammadAttributeEscalationAt: 'Eskalation am',
    zammadAttributeFirstResponseEscalationAt: 'Eskalation am (Erstreaktionszeit)',
    zammadAttributeUpdateEscalationAt: 'Eskalation am (Aktualisierungszeit)',
    zammadAttributeCloseEscalationAt: 'Eskalation am (Schließzeit)',
    zammadAttributeLastContactAt: 'Letzter Kontakt',
    zammadAttributeLastContactAgentAt: 'Letzter Kontakt (Agent)',
    zammadAttributeLastContactCustomerAt: 'Letzter Kontakt (Kunde)',
    zammadAttributeFirstResponseAt: 'Erstreaktion',
    zammadAttributeCloseAt: 'Schließzeit',
    zammadAttributeLastCloseAt: 'Letzte Schließzeit',
    zammadAttributeCreatedBy: 'Erstellt von',
    zammadAttributeCreatedAt: 'Erstellt am',
    zammadAttributeUpdatedBy: 'Aktualisiert von',
    zammadAttributeUpdatedAt: 'Aktualisiert am',
    zammadCategoryMyAssigned: 'Meine zugewiesenen Tickets',
    zammadCategoryAllUnassigned: 'Nicht zugewiesene & offene Tickets',
    zammadCategoryMyPendingReached: 'Meine "Warten erreicht" Tickets',
    zammadCategoryMySubscribed: 'Meine abonnierten Tickets',
    zammadCategoryAllOpen: 'Offene Tickets',
    zammadCategoryAllPendingReached: '"Warten erreicht" Tickets',
    zammadCategoryAllEscalated: 'Eskalierte Tickets',
    zammadCategoryMyTickets: 'Meine Tickets',
    zammadCategoryMyOrganization: 'Tickets meiner Organisation',
    zammadStateNew: 'Neu',
    zammadStateOpen: 'Offen',
    zammadStatePendingReminder: 'Warten auf Erinnerung',
    zammadStatePendingClose: 'Warten auf Schließen',
    zammadStateClosed: 'Geschlossen',
    zammadPriorityLow: 'Niedrig',
    zammadPriorityNormal: 'Normal',
    zammadPriorityHigh: 'Hoch',
    // OPENPROJECT WIDGET
    openProjectWidgetTitle: 'OpenProject',
    openProjectWidgetViewLabel: 'Anzeigen',
    openProjectWidgetViewAssigned: 'Mir zugewiesen',
    openProjectWidgetViewWatched: 'Von mir beobachtet',
    openProjectWidgetViewCreated: 'Von mir erstellt',
    openProjectWidgetEmptyState: 'Keine offenen Arbeitspakete.',
    openProjectWidgetErrorMessage: 'Ihre Arbeitspakete konnten nicht geladen werden.',
    openProjectWidgetUnreachableMessage: 'OpenProject ist gerade nicht erreichbar.',
    openProjectWidgetTokenInvalidMessage: 'OpenProject akzeptiert Ihren API-Token nicht mehr. Bitte verbinden Sie sich erneut.',
    openProjectWidgetRetryButton: 'Erneut versuchen',
    openProjectWidgetReconnectButton: 'Erneut verbinden',
    openProjectWidgetLoadMoreButton: 'Mehr anzeigen',
    openProjectWidgetOverdueLabel: 'Überfällig',
    openProjectWidgetDisconnectedHeading: 'Widget mit OpenProject verknüpfen',
    openProjectWidgetConnectDescription: 'Verbinden Sie Ihr OpenProject-Konto, um hier Ihre Arbeitspakete zu sehen.',
    openProjectWidgetConnectTitle: 'OpenProject-Konto verbinden',
    openProjectWidgetConnectBackDescription: 'Erstellen Sie in OpenProject einen API-Token und fügen Sie diesen hier ein.',
    openProjectWidgetConnectBaseUrlLabel: 'OpenProject-URL',
    openProjectWidgetConnectTokenLabel: 'Ihr API-Token',
    openProjectWidgetConnectButton: 'Verbinden',
    openProjectWidgetConnectTokenInvalidError: 'OpenProject hat diesen API-Token nicht akzeptiert.',
    openProjectWidgetHelpResourcesLabel: 'Hilfe & Ressourcen',
    openProjectWidgetGenerateTokenLabel: 'API-Token erstellen',
    openProjectWidgetGenerateTokenText: 'Kontoeinstellungen → Zugriffstoken in OpenProject',
    openProjectWidgetSettingsTitle: 'Einstellungen',
    openProjectWidgetDisconnectButton: 'OpenProject-Konto trennen',
    openProjectWidgetDisconnectConfirmTitle: 'OpenProject trennen?',
    openProjectWidgetDisconnectConfirmWarning: 'Sie sehen hier keine Arbeitspakete mehr, bis Sie sich erneut verbinden.',
    // COLIBO WIDGET
    coliboWidgetTitle: 'Colibo – Newsfeed',
    coliboWidgetDisconnectedHeading: 'Colibo verbinden',
    coliboWidgetConnectDescription: 'Melden Sie sich einmal bei Colibo an, um hier Ihre Intranet-News zu sehen.',
    coliboWidgetConnectButton: 'Bei Colibo anmelden',
    coliboWidgetConnecting: 'Warte auf das Colibo-Anmeldefenster…',
    coliboWidgetPopupBlocked: 'Ihr Browser hat das Anmeldefenster blockiert. Bitte erlauben Sie Pop-ups für ivCAMPUS und versuchen Sie es erneut.',
    coliboWidgetEmptyState: 'Gerade keine News.',
    coliboWidgetErrorMessage: 'Die News konnten nicht geladen werden.',
    coliboWidgetUnreachableMessage: 'Colibo ist gerade nicht erreichbar.',
    coliboWidgetTokenInvalidMessage: 'Ihre Colibo-Anmeldung ist abgelaufen.',
    coliboWidgetReconnectButton: 'Erneut anmelden',
    coliboWidgetRetryButton: 'Erneut versuchen',
    coliboWidgetLoadMoreButton: 'Mehr laden',
    coliboWidgetPinned: 'Angeheftet',
    coliboWidgetAccountTitle: 'Colibo-Konto',
    coliboWidgetDisconnectButton: 'Colibo trennen',
    coliboWidgetDisconnectConfirmTitle: 'Colibo trennen?',
    coliboWidgetDisconnectConfirmWarning: 'Sie sehen hier keine Colibo-Neuigkeiten mehr, bis Sie sich erneut anmelden.',
    coliboWidgetDisconnectConfirm: 'Trennen',
    // MATRIX CHAT WIDGET
    matrixChatWidgetTitle: 'E2EE Chat',
    matrixChatWidgetUnavailable:
        'Der Secure Chat ist derzeit nicht verfügbar – bitte senden Sie Fluid-Nachrichten oder sprechen Sie direkt mit Ihren Kollegen.',
    matrixChatWidgetConnecting: 'Verbindung zum sicheren Chat wird hergestellt…',
    matrixChatWidgetReconnecting: 'Verbindung zum sicheren Chat wird wiederhergestellt…',
    matrixChatWidgetDisconnected: 'Der sichere Chat ist getrennt.',
    matrixChatWidgetReconnectButton: 'Wiederverbinden',
    matrixChatWidgetPersonalSection: 'Persönlich',
    matrixChatWidgetGroupsSection: 'Gruppen',
    matrixChatWidgetSearchPlaceholder: 'Namen / Gruppen suchen',
    matrixChatWidgetEmptyList: 'Noch keine Unterhaltungen.',
    matrixChatWidgetNewChatHoverText: 'Neuer Chat',
    matrixChatWidgetNewGroupHoverText: 'Neue Gruppe',
    matrixChatWidgetCreateChatTitle: 'Neuen Chat starten',
    matrixChatWidgetCreateGroupChatTitle: 'Neuen Gruppenchat starten',
    matrixChatWidgetCreateChatConfirm: 'Chat starten',
    matrixChatWidgetCreateChatCancel: 'Abbrechen',
    matrixChatWidgetGroupChatMinMembersHint: 'Wähle mindestens 2 Personen aus, um einen Gruppenchat zu starten',
    matrixChatWidgetComposerPlaceholder: 'Nachricht…',
    matrixChatWidgetEncryptedLabel: 'Ende-zu-Ende verschlüsselt',
    matrixChatWidgetSendWithEnterLabel: 'Nachricht mit Enter senden',
    matrixChatWidgetSendWithEnterOnHint: 'Ein: Die Eingabetaste sendet deine Nachricht.',
    matrixChatWidgetSendWithEnterOffHint: 'Aus: Strg/Cmd + Eingabetaste sendet deine Nachricht.',
    matrixChatWidgetFontSizeLabel: 'Textgröße der Nachrichten',
    matrixChatWidgetSettingsTitle: 'Einstellungen',
    matrixChatWidgetExternalClientLabel: 'Andere Chat-App verwenden',
    matrixChatWidgetExternalClientHint: 'Verwende diese Angaben, um dich in Thunderbird oder einer anderen Matrix-kompatiblen Chat-App anzumelden.',
    matrixChatWidgetExternalClientButton: 'Anmeldedaten anzeigen',
    matrixChatWidgetExternalClientHideButton: 'Anmeldedaten ausblenden',
    matrixChatWidgetExternalClientPasswordWarning:
        'Ändere dein Passwort nicht in Thunderbird oder einer anderen App - das würde dich hier im Web-Chat abmelden und dieses Passwort ungültig machen.',
    matrixChatWidgetExternalClientMatrixIdLabel: 'Matrix-ID',
    matrixChatWidgetExternalClientHomeserverLabel: 'Homeserver',
    matrixChatWidgetExternalClientPasswordLabel: 'Passwort',
    matrixChatWidgetExternalClientRecoveryKeyLabel: 'Wiederherstellungsschlüssel',
    matrixChatWidgetExternalClientRecoveryKeyHint:
        'Wenn die App dich bittet, dieses Gerät zu verifizieren oder einen Sicherheits-/Wiederherstellungsschlüssel einzugeben, füge diesen Wert ein.',
    matrixChatWidgetExternalClientCopyButton: 'Kopieren',
    matrixChatWidgetExternalClientError: 'Deine Anmeldedaten konnten nicht geladen werden. Bitte versuche es erneut.',
    matrixChatWidgetHelpResourcesLabel: 'Hilfe & Ressourcen',
    matrixChatWidgetInviteLinkLabel: 'Einladungslink senden',
    matrixChatWidgetInviteLinkHint: 'Teile diesen Link, damit andere dich in jeder Matrix-kompatiblen Chat-App finden und dir schreiben können.',
    matrixChatWidgetInviteLinkCopyButton: 'Einladungslink kopieren',
    matrixChatWidgetGuideLinkLabel: 'Anleitung',
    matrixChatWidgetGuideLinkText: 'So chattest, meldest dich an und verbindest andere Apps',
    matrixChatWidgetSettingsBackButton: 'Zurück',
    matrixChatWidgetStartChatPrompt: 'Chat mit {0} starten?',
    matrixChatWidgetStartGroupChatPrompt: 'Gruppenchat mit {0} starten?',
    matrixChatWidgetPresencePromptDismiss: 'Nicht jetzt',
    matrixChatWidgetLeaveChatTooltip: 'Chat verlassen',
    matrixChatWidgetLeaveChatTitle: 'Diesen Chat verlassen?',
    matrixChatWidgetLeaveChatBody:
        'Dies entfernt den Chat nur aus deiner Liste, du erhältst dann keine Nachrichten mehr. Für andere Teilnehmer bleibt der Chat bestehen.',
    matrixChatWidgetLeaveChatConfirm: 'Verlassen',
    matrixChatWidgetLeaveChatCancel: 'Abbrechen',
    matrixChatWidgetAttachTooltip: 'Datei anhängen',
    matrixChatWidgetDownloadTooltip: 'Herunterladen',
    matrixChatWidgetUploadError: 'Die Datei konnte nicht gesendet werden. Bitte versuche es erneut.',
    matrixChatWidgetFileTooLargeError: 'Die Datei ist zu groß. Die maximale Größe beträgt 50 MB.',
    matrixChatWidgetPreviewUnavailable: 'Für diesen Dateityp ist keine Vorschau verfügbar. Zum Öffnen herunterladen.',
    matrixChatWidgetAddReactionTooltip: 'Reaktion hinzufügen',
    calendarWidgetTitle: 'Kalender',
    calendarWidgetConnectDescription: 'Verbinde dein Microsoft-Konto, um die heutigen Termine zu sehen.',
    calendarWidgetConnectButton: 'Kalender verbinden',
    calendarWidgetSharedLoginTooltip: 'Die Anmeldung verbindet E-Mail, Kalender und Aufgaben auf einmal.',
    calendarWidgetEmptyDay: 'Keine Termine heute.',
    calendarWidgetErrorMessage: 'Etwas ist schiefgelaufen.',
    calendarWidgetRetryButton: 'Erneut versuchen',
    calendarWidgetNewEventButton: 'Neuer Termin heute',
    calendarWidgetDeleteButton: 'Löschen',
    calendarWidgetDeleteConfirm: 'Diesen Termin löschen?',
    calendarWidgetCancelButton: 'Abbrechen',
    calendarWidgetSaveButton: 'Speichern',
    calendarWidgetTitleLabel: 'Titel',
    calendarWidgetStartLabel: 'Beginn',
    calendarWidgetEndLabel: 'Ende',
    calendarWidgetLocationLabel: 'Ort',
    calendarWidgetDescriptionLabel: 'Beschreibung',
    calendarWidgetDeleteFailed: 'Löschen fehlgeschlagen. Bitte erneut versuchen.',
    calendarWidgetSaveFailed: 'Speichern fehlgeschlagen. Bitte erneut versuchen.',
    calendarWidgetJoinButton: 'Beitreten',
    calendarWidgetAttendeesLabel: 'Teilnehmer',
    calendarWidgetAccountSettingsTitle: 'Konto',
    calendarWidgetDisconnectButton: 'Trennen',
    calendarWidgetBackButton: 'Zurück',
    calendarWidgetEditButton: 'Bearbeiten',
    calendarWidgetEditEventTitle: 'Termin bearbeiten',
    calendarWidgetEditFailed: 'Aktualisieren fehlgeschlagen. Bitte erneut versuchen.',
    calendarWidgetDateLabel: 'Datum',
    calendarWidgetAttendeePlaceholder: 'E-Mail-Adresse',
    todosWidgetTitle: 'Aufgaben',
    todosWidgetConnectDescription: 'Verbinde dein Microsoft-Konto, um deine Aufgaben zu sehen.',
    todosWidgetConnectButton: 'Aufgaben verbinden',
    todosWidgetSharedLoginTooltip: 'Die Anmeldung verbindet E-Mail, Kalender und Aufgaben auf einmal.',
    todosWidgetEmptyList: 'Keine offenen Aufgaben.',
    todosWidgetErrorMessage: 'Etwas ist schiefgelaufen.',
    todosWidgetRetryButton: 'Erneut versuchen',
    todosWidgetInputPlaceholder: 'Aufgabe hinzufügen...',
    todosWidgetTitleLabel: 'Titel',
    todosWidgetDeleteFailed: 'Löschen fehlgeschlagen. Bitte erneut versuchen.',
    todosWidgetCompleteFailed: 'Abschließen fehlgeschlagen. Bitte erneut versuchen.',
    todosWidgetCreateFailed: 'Erstellen fehlgeschlagen. Bitte erneut versuchen.',
    todosWidgetDueToday: 'Heute fällig',
    todosWidgetDueTomorrow: 'Morgen fällig',
    todosWidgetDuePrefix: 'Fällig',
    todosWidgetOverdue: 'Überfällig',
    todosWidgetToday: 'Heute',
    todosWidgetTomorrow: 'Morgen',
    todosWidgetOverdueDaysSuffix: 'T.',
    todosWidgetUpcoming: 'Anstehend',
    todosWidgetAddButton: 'Hinzufügen',
    todosWidgetNewTaskTitle: 'Neue Aufgabe',
    todosWidgetCancelButton: 'Abbrechen',
    todosWidgetAccountSettingsTitle: 'Konto',
    todosWidgetBackButton: 'Zurück',
    todosWidgetEditFailed: 'Aktualisieren fehlgeschlagen. Bitte erneut versuchen.',
    todosWidgetDueDateLabel: 'Fälligkeitsdatum',
    todosWidgetReminderLabel: 'Erinnerung',
    todosWidgetRecurrenceLabel: 'Wiederholen',
    todosWidgetRecurrenceNone: 'Keine',
    todosWidgetRecurrenceDaily: 'Täglich',
    todosWidgetRecurrenceWeekly: 'Wöchentlich',
    todosWidgetRecurrenceMonthly: 'Monatlich',
    todosWidgetRecurrenceYearly: 'Jährlich',
    todosWidgetRecurrenceEditHint: 'Wiederholung kann nur in Microsoft To Do geändert werden.',
    todosWidgetOpenInMicrosoftTodo: 'In Microsoft To Do öffnen',
    providerConnectionPanelTitle: 'Anbieter',
    providerConnectionPanelNoProviderHeading: 'Noch kein Anbieter verbunden',
    providerConnectionPanelNoProviderSubtext: 'Verbinde deinen Anbieter, um zu beginnen',
    providerConnectionPanelConnectedTab: 'Verbunden',
    providerConnectionPanelOtherTab: 'Weitere Anbieter',
    providerConnectionPanelComingSoon: 'Demnächst verfügbar',
    providerConnectionPanelDisconnect: 'Trennen',
    providerConnectionPanelBackButton: 'Zurück',
    widgetFilterLabel: 'Filter',
    widgetFilterLegendLabel: 'Filter / Legende',
    calendarWidgetFilterLegend: 'Zeigt ausschließlich die heutigen Kalendereinträge an.',
    emailWidgetFilterLegend: 'Zeigt die Emails von heute sowie die ungelesenen Emails von gestern an.',
    todosWidgetFilterLegend: 'Zeigt überfällige, heutige und die Aufgaben der aktuellen Woche an — also nur Aufgaben bis Sonntag dieser Woche.',
    widgetSettingsHoverText: 'Einstellungen / Filter',
    widgetOpenInAppHoverText: 'App aufrufen',
    widgetRefreshHoverText: 'Aktualisieren',
    providerMicrosoftName: 'Microsoft',
    providerGoogleName: 'Google',
    providerOtherName: 'Weitere Anbieter',
    outlookWidgetDisconnectedSubtext: 'Verbinde einen Anbieter, um auf deine Mails zuzugreifen.',
    calendarWidgetDisconnectedSubtext: 'Verbinde einen Anbieter, um auf deinen Kalender zuzugreifen.',
    todosWidgetDisconnectedSubtext: 'Verbinde einen Anbieter, um auf deine Aufgaben zuzugreifen.',
    microsoftProviderTitle: 'Microsoft',
    microsoftProviderDescription: 'Aktivieren der Anzeige von Widgets auf dem Schreibtisch (Microsoft Mail, Kalender, Aufgaben) für alle CAMPUS-Mitglieder',
    googleProviderTitle: 'Google',
    googleProviderDescription: 'Aktiviere Google-Integrationen (Gmail, Kalender, Aufgaben) für deine Campus-Mitglieder.',
    providerEnabledLabel: 'Aktiviert',
    providerDisabledLabel: 'Deaktiviert',

    // CAMPUS SETTINGS - organization
    organizationTitle: 'Organisation',

    // WebBrowserNotification
    notificationTitle: 'Benachrichtigungseinstellungen verwalten',
    notificationRequestMessage: 'Klicken Sie auf die Schaltfläche unten, um Browser-Benachrichtigungen zu aktivieren:',
    notificationRequestButton: 'Benachrichtigungen aktivieren',
    notificationEnabledText: 'Benachrichtigungen aktiviert!',
    notificationCopyInstruction:
        'Kopieren Sie den Link unten und fügen Sie ihn in einen neuen Tab ein, um Ihre Browser-Benachrichtigungseinstellungen zu verwalten:',
    notificationCopyButton: 'Link kopieren',
    notificationCopiedText: 'Kopiert',
    notificationGuideText: 'Sehen Sie sich die ausführliche Anleitung zur Verwaltung von System- und Browser-Benachrichtigungen an:',
    notificationGuideLinkText: 'Klicken Sie hier, um die Anleitung in einem neuen Tab zu öffnen',
    notificationCloseButton: 'Schließen',
    notificationMessageTitle: 'Sie scheinen auf Ihrem CAMPUS abwesend zu sein!',
    notificationMessageBody: 'Werden Sie für Ihre Kollegen wieder sichtbar: Klicken Sie hier',

    // WebRTCDiagnostics
    sectionBasic: 'Grundinformationen',
    sectionCallNetwork: 'Anrufprobleme und Netzwerkinformationen',
    sectionAdditional: 'Zusätzliche Informationen',
    sectionFirewall: 'Firewall-Einstellungen',
    webRTCDiagnosticsChecklistTitle: 'ivCAMPUS Video-Anruf Fehlerbehebungs-Checkliste',
    webRTCDiagnosticsTitle: 'WebRTC Diagnose',
    webRTCDiagnosticsBrowserLabel: 'Welchen Webbrowser verwenden Sie?',
    webRTCDiagnosticsBrowserOther: 'Anderer',
    webRTCDiagnosticsBrowserUpdatedLabel: 'Ist Ihr Webbrowser auf dem neuesten Stand?',
    webRTCDiagnosticsBrowserUpdatedUnknown: 'Ich weiß nicht',
    webRTCDiagnosticsBrowserVersionLabel: 'Browser-Version',
    webRTCDiagnosticsBrowserVersionPlaceholder: 'z.B. 120.0.6099.129',
    webRTCDiagnosticsInternetConnectionLabel: 'Haben Sie eine stabile Internetverbindung?',
    webRTCDiagnosticsInternetConnectionLabelSometimes: 'Manchmal',
    webRTCDiagnosticsSpeedTestLabel: 'Geschwindigkeitstest durchführen',
    webRTCDiagnosticsSpeedTestResultLabel: 'Geschwindigkeitstest-Ergebnis (optional) oder fügen Sie einen Screenshot hinzu (Upload-Option im letzten Schritt)',
    webRTCDiagnosticsMicrophoneLabel: 'Funktioniert Ihr Mikrofon in anderen Anwendungen?',
    webRTCDiagnosticsCameraLabel: 'Funktioniert Ihre Kamera in anderen Anwendungen?',
    webRTCDiagnosticsPermissionsLabel: 'Haben Sie ivCAMPUS in Ihren Browser-Einstellungen die Berechtigungen für Mikrofon und Kamera erteilt?',
    webRTCDiagnosticsCallIssuesLabel: 'Können Sie andere Teilnehmer sehen und hören?',
    webRTCDiagnosticsCallIssuesNoneWorking: 'Nein (Weder Audio noch Video)',
    webRTCDiagnosticsCallIssuesAudioOnly: 'Ich kann sie hören, aber nicht sehen',
    webRTCDiagnosticsCallIssuesVideoOnly: 'Ich kann sie sehen, aber nicht hören',
    webRTCDiagnosticsCallIssuesChoppy: 'Beide Audio und Video sind stockend oder instabil',
    webRTCDiagnosticsCallIssues: {
        allWorking: 'alles_funktioniert',
        noneWorking: 'nichts_funktioniert',
        audioOnly: 'nur_audio',
        videoOnly: 'nur_video',
        choppy: 'stockend'
    },
    webRTCDiagnosticsChoppyDescriptionLabel: 'Beschreiben Sie die stockende Übertragung',
    webRTCDiagnosticsOthersCanSeeHearLabel: 'Können andere Teilnehmer Sie sehen und hören?',
    webRTCDiagnosticsVPNLabel: 'Verwenden Sie ein VPN?',
    webRTCDiagnosticsManagedITLabel: 'Wird Ihr Netzwerk von einer IT-Abteilung verwaltet?',
    webRTCDiagnosticsRegionalITLabel: 'Wird Ihr Netzwerk von einem regionalen IT-Dienstleister verwaltet?',
    webRTCDiagnosticsAdditionalIssueStartDate: 'Wann ist das Problem aufgetreten?',
    webRTCDiagnosticsAdditionalIssueFrequency: 'Häufigkeit des Problems (z.B. bei jedem Anruf, spezifisch, Heim- oder Büroarbeit)',
    webRTCDiagnosticsAdditionalIssueOtherParticipants: 'Sind andere Teilnehmer mit demselben Problem konfrontiert?',
    webRTCDiagnosticsAdditionalIssueAnyOtherIssues: 'Weitere relevante Details?',
    webRTCDiagnosticsOperatingSystemLabel: 'Wählen Sie Ihr Betriebssystem:',
    webRTCDiagnosticsFirewallTitle: 'Firewall-Konfiguration',
    webRTCDiagnosticsFirewallDescription:
        'Bitten Sie einen IT-Kollegen zu überprüfen, ob die nachfolgenden Server bzw. Ports, die in Ihrer Firewall zugelassen sind.',
    webRTCDiagnosticsFirewallTURNServer: 'ivicos-turn.ivicos-campus.app (185.233.188.204)',
    webRTCDiagnosticsFirewallJVBServer: 'ivicos-jvb.ivicos-campus.app (185.233.188.253)',
    webRTCDiagnosticsFirewallJitsiServer: 'ivicos-jitsi.ivicos-campus.app (185.233.189.35)',
    webRTCDiagnosticsFirewallPort80: 'Port 80/tcp (HTTP)',
    webRTCDiagnosticsFirewallPort443: 'Port 443/tcp (HTTPS)',
    webRTCDiagnosticsFirewallPort4443: 'Port 4443/tcp (TCP)',
    webRTCDiagnosticsFirewallPort10000: 'Port 10000/udp (UDP) – Wichtig für Audio/Video-Qualität',
    webRTCDiagnosticsScreenshotsTitle: 'Screenshots hochladen (optional)',
    webRTCDiagnosticsScreenshotsCount: 'Screenshot(s) hochgeladen',
    webRTCDiagnosticsGenerateReportButton: 'Fehlerbehebungs-Bericht generieren (PDF)',
    webRTCDiagnosticsShowTestEnvironment: {
        show: 'Testumgebung anzeigen',
        hide: 'Testumgebung ausblenden',
        title: 'Jitsi-Testumgebung (optional)',
        step1: 'Schritt 1: Öffnen Sie ein Inkognito-/privates Fenster',
        step1Description: 'Für die beste Testerfahrung öffnen Sie bitte den Testlink in einem Inkognito- oder privaten Fenster, je nach Browser:',
        command1: 'Drücken Sie Strg+Umschalt+N (Windows/Linux) oder ⌘+Umschalt+N (Mac)',
        command2: 'Drücken Sie Strg+Umschalt+P (Windows/Linux) oder ⌘+Umschalt+P (Mac)',
        step2: 'Schritt 2: Kopieren Sie den unten genannten Testlink und fügen Sie ihn im Inkognito-/privaten Fenster ein',
        copyLink: 'Link kopieren',
        linkCopied: 'Link kopiert',
        step3: 'Hinweis: Die Verwendung eines Inkognito-/privaten Fensters stellt sicher, dass Ihre aktuellen Browser-Sitzungen und Cookies die Testumgebung nicht beeinflussen.'
    },
    webRTCDiagnosticsGeneratedReport: {
        title: 'ivCAMPUS Videoanruf-Fehlerbehebungsbericht',
        generatedOn: 'Erstellt am:',
        basicInformation: 'Grundlegende Informationen',
        category: 'Kategorie',
        status: 'Status',
        browser: 'Browser',
        browserUpdated: 'Ist der Browser aktuell?',
        browserVersion: 'Browser-Version',
        internetConnection: 'Ist die Internetverbindung stabil?',
        speedTestResult: 'Geschwindigkeitstest-Ergebnis',
        operatingSystem: 'Betriebssystem',
        deviceChecks: 'Geräteprüfungen',
        check: 'Prüfung',
        microphoneWorking: 'Wird das Mikrofon von einer anderen Anwendung verwendet?',
        cameraWorking: 'Wird die Kamera von einer anderen Anwendung verwendet?',
        permissionsGranted: 'Berechtigungen für ivCAMPUS erteilt',
        callIssues: 'Anrufprobleme',
        issue: 'Problem',
        callIssuesStatus: 'Anrufprobleme',
        othersCanSeeHear: 'Andere können sehen/hören',
        usingVPN: 'VPN wird verwendet',
        managedIT: 'IT-Verwaltung',
        regionalIT: 'Regionale IT',
        choppyDescription: 'Beschreibung der Unterbrechungen',
        firewallConfiguration: 'Firewall-Konfiguration',
        servicePort: 'Dienst/Port',
        turnServer: 'TURN-Server',
        jvbServer: 'JVB-Server',
        jitsiServer: 'Jitsi-Server',
        port80: 'Port 80',
        port443: 'Port 443',
        port4443: 'Port 4443',
        port10000: 'Port 10000',
        allowed: 'Erlaubt',
        blocked: 'Blockiert',
        additionalInformation: 'Zusätzliche Informationen',
        details: 'Details',
        issueStartDate: 'Problemstart-Datum',
        issueFrequency: 'Problemhäufigkeit',
        otherParticipantsIssue: 'Problem bei anderen Teilnehmern',
        additionalDetails: 'Weitere Details',
        screenshots: 'Screenshots',
        screenshot: 'Screenshot',
        errorLoadingScreenshot: 'Fehler beim Laden des Screenshots',
        notProvided: 'Nicht angegeben',
        page: 'Seite',
        of: 'von'
    },
    resetWizard: {
        title: 'Anwendung zurücksetzen',
        description1:
            'Klicken Sie auf die Schaltfläche unten, um die Anwendungsdaten vom ivCAMPUS zu löschen, einschließlich lokal zwischengespeicherter Inhalte und Sitzungsinformationen',
        description2: 'Dies kann helfen, Probleme mit der Anwendung bzw. Konflikte zu beheben.',
        reset: 'Zurücksetzen',
        resetComplete: 'Erledigt! Alle Cache- und Speicherdaten für die Seite ivicos-campus.app wurden entfernt.'
    },
    // Personal Meeting Corner
    personalMeetingCornerStrings: {
        // Add Widgets
        addWidgets: {
            addWidget: 'Widget hinzufügen',
            addWidgetAriaLabel: 'Widget hinzufügen'
        },

        // Widget Creation
        createWidget: {
            createWidget: 'Persönliches Widget mit Favoriten oder Tipp erstellen',
            updateWidget: 'Persönliches Widget mit Favoriten oder Tipp aktualisieren',
            close: 'Schließen',
            artGallery: 'Kunstgalerie',
            imageUpload: 'Fotos',
            quote: 'Zitat',
            urls: 'Webseiten',
            book: 'Buch-Tipp',
            anotherLife: 'Anderes Leben',
            anotherLifeSection: 'Anderes Leben Bereich (wird noch implementiert)',
            preserveAspectRatio: 'Bild vollständig anzeigen',
            header: 'Kopfzeile',
            widgetHeader: 'Widget-Kopfzeile',
            footer: 'Fußzeile',
            widgetFooter: 'Widget-Fußzeile',
            createWidgetButton: 'Widget erstellen',
            updateWidgetButton: 'Widget aktualisieren'
        },

        // Art Gallery Widget
        artGallery: {
            searchPlaceholder: 'National Gallery Kunstwerke durchsuchen...',
            searchingCollections: 'Durchsuche Sammlungen...',
            artist: 'Künstler: {artist}',
            medium: 'Medium: {medium}',
            date: 'Datum: {date}'
        },

        // Image Upload Widget
        imageUpload: {
            upload: 'Hochladen',
            searchUnsplashHeader: 'Unsplash durchsuchen',
            clickOrDragToUpload: 'Klicken oder Foto zum Hochladen hierher ziehen',
            searchUnsplash: 'Unsplash durchsuchen...',
            loading: 'Lädt...',
            description: 'Beschreibung',
            photoByAuthor: 'Foto von {authorName} auf {unsplash}',
            author: 'Autor: {authorName}',
            sourceUnsplash: 'Quelle: Unsplash',
            imageLink: 'Bildlink'
        },

        // Quote Widget
        quote: {
            chooseCategory: 'Kategorie wählen...',
            fetchingQuote: 'Zitat wird abgerufen...',
            getQuote: 'Zitat abrufen',
            noQuoteGenerated: 'Kein Zitat generiert.',
            useThisQuote: 'Dieses Zitat verwenden',
            quoteLabel: 'Zitat (max. 400 Zeichen)',
            quotePlaceholder: 'Geben Sie Ihr Lieblingszitat ein...',
            authorLabel: 'Autor',
            authorPlaceholder: 'Autor des Zitats',
            quoteCategories: {
                inspirational: 'Inspirierend',
                motivational: 'Motivierend',
                life: 'Leben',
                love: 'Liebe',
                success: 'Erfolg',
                wisdom: 'Weisheit',
                happiness: 'Glück',
                friendship: 'Freundschaft'
            }
        },

        // URL Widget
        url: {
            dragDropUrls: 'URLs hier aus dem Browser ziehen',
            enterUrlsManually: 'Oder URLs manuell im Eingabefeld unten eingeben',
            enterUrlPlaceholder: 'URL eingeben (z.B. https://ivicos.eu)',
            add: 'Hinzufügen',
            links: 'Links',
            noLinksAdded: 'Noch keine Links hinzugefügt',
            addFirstLink: 'Fügen Sie oben Ihren ersten empfohlenen Link hinzu',
            recommendedLink: 'Empfohlener Link',
            recommendedLinks: 'Empfohlene Links',
            recommendedLinksReorder: 'Empfohlene Links (zum Neuordnen ziehen)',
            pleaseEnterUrl: 'Bitte geben Sie eine URL ein',
            maxLinksAllowed: 'Maximal 10 Links erlaubt',
            pleaseDropValidUrl: 'Bitte eine gültige URL einfügen',
            openLink: 'Link öffnen',
            removeLink: 'Link entfernen',
            more: 'mehr'
        },

        // Book Widget
        book: {
            searchForBook: 'Nach einem Buch suchen',
            searchPlaceholder: 'Titel, Autor oder ISBN',
            searching: 'Suche...',
            search: 'Suchen',
            pleaseEnterSearchTerm: 'Bitte geben Sie einen Suchbegriff ein.',
            searchingBooks: 'Durchsuche Bücher...',
            author: 'Autor: {authorName}',
            published: 'Veröffentlicht: {publishedDate}',
            isbn: 'ISBN: {isbnNumber}',
            source: 'Quelle: ',
            openLibrary: 'Open Library',
            bookCover: 'Buchcover',
            fallbackBookCover: {
                bookRecommendation: 'Buchempfehlung',
                clickHere: 'hier klicken',
                photoBy: 'Foto von',
                on: 'auf'
            }
        },

        // Tooltips
        tooltips: {
            main: {
                personalDashboard: 'Mein Schreibtisch',
                personalMeetingCorner: 'Mein Besprechungstisch',
                saveChanges: 'Widgets speichern und zurück zum Schreibtisch'
            },
            expandWidgets: 'Widgets einblenden',
            collapseWidgets: 'Widgets ausblenden',
            addWidget: 'Widget hinzufügen',
            editWidget: 'Widget bearbeiten',
            deleteWidget: 'Widget löschen',
            openLink: 'Link in neuem Tab öffnen',
            removeLink: 'Link entfernen'
        }
    },

    // SAML
    samlUnknownProviderTitle: 'Unbekannter Anmeldeanbieter',
    samlUnknownProviderMessage: 'Die angeforderte Anmeldeseite existiert nicht. Bitte überprüfen Sie Ihren Link oder wenden Sie sich an Ihren Administrator.',
    samlUnknownProviderBack: 'Zurück zur Anmeldung',
    dashboardBackgroundImageTitle: 'Dashboard-Hintergrundbild',
    dashboardBackgroundModalTitle: 'Dashboard-Hintergrund',
    dashboardBackgroundModalSubtitle: 'Wähle einen festen Hintergrund für das Dashboard aller Nutzer. Widgets scrollen über den Hintergrund.',
    dashboardBackgroundCurrentSelection: 'Aktuelle Auswahl',
    disableProviderDialogTitle: '{0} deaktivieren?',
    disableProviderDialogWarning: 'Alle {0}-Widgets auf CAMPUS werden auf allen Schreibtischen ausgeblendet.',
    disableProviderDialogCancel: 'Abbrechen',
    disableProviderDialogConfirm: 'Deaktivieren',
    // ZAMMAD SETTINGS
    zammadSettingsToggleLabel: 'Zammad',
    zammadSettingsBaseUrlLabel: 'Zammad Base URL',
    zammadSettingsSaveButton: 'Speichern',
    zammadSettingsCancelButton: 'Abbrechen',
    zammadSettingsConfiguredStatus: 'Konfiguriert',
    zammadSettingsNotConfiguredStatus: 'Nicht konfiguriert',
    zammadTicketSettingsToggleLabel: 'Zammad – Ticket erstellen',
    zammadTicketSettingsDeliveryLabel: 'Zustellung',
    zammadTicketSettingsDeliveryEmail: 'Per E-Mail',
    zammadTicketSettingsDeliveryForm: 'Zammad-Formular',
    zammadTicketSettingsTargetEmailLabel: 'Ziel-E-Mail',
    zammadTicketSettingsEmailHint:
        'ivCAMPUS sendet jedes Ticket mit der meldenden Person als Reply-To. Wählen Sie in Zammad unter „Absender basierend auf Reply-To-Header“ die Option „Nutze "Reply-To"-Feld als Absender einer E-Mail.“, damit diese Person Kunde des Tickets wird.',
    zammadTicketSettingsFormUrlLabel: 'Zammad-URL',
    zammadTicketSettingsFormHint: 'In Zammad muss der Kanal „Formular" aktiviert sein, ohne CAPTCHA.',
    zammadTicketSettingsCategoriesLabel: 'Kategorien (eine pro Zeile, optional)',
    zammadTicketSettingsInvalidEmail: 'Bitte eine gültige E-Mail-Adresse eingeben.',
    zammadTicketSettingsInvalidUrl: 'Bitte eine https://-Adresse eingeben.',
    zammadTicketSettingsInvalidCategories: 'Bis zu 20 Kategorien mit je höchstens 50 Zeichen.',
    zammadTicketWidgetTitle: 'Zammad – Ticket erstellen',
    zammadTicketWidgetCategoryLabel: 'Kategorie',
    zammadTicketWidgetSubjectLabel: 'Betreff',
    zammadTicketWidgetSubjectPlaceholder: 'Worum geht es?',
    zammadTicketWidgetBodyLabel: 'Beschreibung',
    zammadTicketWidgetBodyPlaceholder: 'Was ist passiert? Was haben Sie schon versucht?',
    zammadTicketWidgetSubmit: 'Ticket senden',
    zammadTicketWidgetCreatedTitle: 'Ticket angelegt',
    zammadTicketWidgetCreatedDescription: 'Die Bestätigung geht per E-Mail. Antworten darauf landen direkt im Ticket.',
    zammadTicketWidgetSentTitle: 'Ticket gesendet',
    zammadTicketWidgetSentDescription: 'Antworten erhalten Sie per E-Mail.',
    zammadTicketWidgetSentReferenceDescription: 'Bitte notieren Sie diese Referenz. Antworten erhalten Sie per E-Mail.',
    zammadTicketWidgetReportAnother: 'Weiteres Ticket erstellen',
    zammadTicketWidgetRequired: 'Pflichtfeld',
    zammadTicketWidgetUnreachable: 'Der Zammad-Server ist nicht erreichbar. Bitte später erneut versuchen.',
    zammadTicketWidgetRejected: 'Zammad hat das Ticket nicht angenommen. Bitte später erneut versuchen.',
    zammadTicketWidgetEmailFailed: 'Das Ticket konnte nicht gesendet werden. Bitte später erneut versuchen.',
    zammadTicketWidgetGenericError: 'Etwas ist schiefgelaufen.',
    zammadTicketWidgetConfigChanged: 'Die Ticket-Einstellungen wurden geändert. Bitte prüfen Sie das Ticket und senden Sie es erneut.',
    zammadTicketWidgetLoadError: 'Das Ticketformular konnte nicht geladen werden.',
    zammadTicketWidgetRetry: 'Erneut versuchen',
    zammadSettingsVerifyFailedError: 'Ungültige Base URL oder Access Token.',
    // OPENPROJECT SETTINGS
    openProjectSettingsToggleLabel: 'OpenProject',
    openProjectSettingsBaseUrlLabel: 'OpenProject-URL',
    openProjectSettingsBaseUrlHint: 'Die https-Adresse Ihres OpenProject, z. B. https://openproject.example.com',
    openProjectSettingsSaveButton: 'Speichern',
    openProjectSettingsCancelButton: 'Abbrechen',
    openProjectSettingsConfiguredStatus: 'Konfiguriert',
    openProjectSettingsNotConfiguredStatus: 'Nicht konfiguriert',
    openProjectSettingsInvalidUrlError: 'Bitte geben Sie eine öffentliche https-Adresse ein.',
    // DOCUMENSO SETTINGS
    documensoSettingsToggleLabel: 'Documenso',
    documensoSettingsBaseUrlLabel: 'Documenso-URL',
    documensoSettingsBaseUrlHint: 'Documenso Cloud ist https://app.documenso.com. Ändern Sie die Adresse nur für ein selbst gehostetes Documenso.',
    documensoSettingsSaveButton: 'Speichern',
    documensoSettingsCancelButton: 'Abbrechen',
    documensoSettingsConfiguredStatus: 'Konfiguriert',
    documensoSettingsNotConfiguredStatus: 'Nicht konfiguriert',
    documensoSettingsInvalidUrlError: 'Bitte geben Sie eine öffentliche https-Adresse ein.',
    // DOCUMENSO WIDGET
    documensoWidgetTitle: 'Documenso',
    documensoWidgetDisconnectedHeading: 'Dokumente mit Documenso signieren',
    documensoWidgetConnectDescription: 'Verbinden Sie Ihr Documenso-Konto, um PDFs zur Unterschrift zu senden.',
    documensoWidgetConnectTitle: 'Documenso verbinden',
    documensoWidgetConnectBackDescription:
        'Fügen Sie ein persönliches API-Token aus Ihrem Documenso-Konto ein. Sie erstellen es in Documenso unter Einstellungen → API-Tokens Ihres persönlichen Teams.',
    documensoWidgetConnectBaseUrlLabel: 'Documenso-URL',
    documensoWidgetConnectTokenLabel: 'API-Token',
    documensoWidgetConnectButton: 'Verbinden',
    documensoWidgetConnectTokenInvalidError: 'Documenso hat dieses Token nicht akzeptiert.',
    documensoWidgetOpenDocumensoLabel: 'Documenso öffnen',
    documensoWidgetGenerateTokenText: 'Dort ein API-Token erstellen',
    documensoWidgetDocumentsTitle: 'Ihre Dokumente',
    documensoWidgetDisconnectButton: 'Documenso trennen',
    documensoWidgetDisconnectConfirmTitle: 'Documenso trennen?',
    documensoWidgetDisconnectConfirmWarning: 'Ihr API-Token wird aus ivCAMPUS entfernt. Ihre Dokumente bleiben in Documenso.',
    documensoWidgetDropZoneText: 'PDF hier ablegen oder klicken, um eine auszuwählen',
    documensoWidgetFileNotPdfError: 'Nur PDF-Dateien können zur Unterschrift gesendet werden.',
    documensoWidgetFileTooLargeError: 'Die PDF ist größer als 20 MB.',
    documensoWidgetTitleLabel: 'Titel',
    documensoWidgetIncludeMeLabel: 'Ich unterschreibe auch',
    documensoWidgetSignersLabel: 'Weitere Unterzeichnende',
    documensoWidgetSignerEmailPlaceholder: 'E-Mail-Adresse',
    documensoWidgetSignerNamePlaceholder: 'Name (optional)',
    documensoWidgetInvalidEmailError: 'Ungültige E-Mail-Adresse',
    documensoWidgetAddSignerButton: 'Unterzeichnende hinzufügen',
    documensoWidgetRemoveSignerLabel: 'Unterzeichnende entfernen',
    documensoWidgetDraftHint: 'Platzieren Sie nach dem Erstellen die Signaturfelder in Documenso und senden Sie das Dokument dort ab.',
    documensoWidgetCreateDraftButton: 'Entwurf erstellen',
    documensoWidgetCancelButton: 'Abbrechen',
    documensoWidgetInvalidRecipientsError: 'Fügen Sie mindestens eine Person mit gültiger E-Mail-Adresse hinzu (höchstens 10, Sie eingeschlossen).',
    documensoWidgetLimitExceededError:
        'Documenso hat kein neues Dokument angenommen. Vermutlich ist das Monatslimit Ihres Tarifs erreicht (Free-Tarif: 5 Dokumente pro Monat). Wechseln Sie in Documenso den Tarif oder versuchen Sie es nächsten Monat erneut.',
    documensoWidgetRateLimitedError: 'Documenso ist ausgelastet, bitte versuchen Sie es in einer Minute erneut.',
    documensoWidgetQuotaCount: '{0} Dokumente in diesem Monat genutzt',
    documensoWidgetQuotaCountOne: '1 Dokument in diesem Monat genutzt',
    documensoWidgetRenewsInDays: 'erneuert sich in {0} Tagen',
    documensoWidgetRenewsTomorrow: 'erneuert sich morgen',
    documensoWidgetProgress: '{0} von {1} unterschrieben',
    documensoWidgetStatusDraft: 'Entwurf',
    documensoWidgetStatusPending: 'Ausstehend',
    documensoWidgetStatusCompleted: 'Abgeschlossen',
    documensoWidgetStatusRejected: 'Abgelehnt',
    documensoWidgetStatusCancelled: 'Storniert',
    documensoWidgetSignerSigned: 'unterschrieben',
    documensoWidgetSignerNotSigned: 'noch nicht unterschrieben',
    documensoWidgetSignerRejected: 'abgelehnt',
    documensoWidgetPlaceFieldsButton: 'Felder platzieren & senden',
    documensoWidgetDiscardButton: 'Verwerfen',
    documensoWidgetSignNowButton: 'Jetzt unterschreiben',
    documensoWidgetWaitingOne: '1 Dokument wartet auf Ihre Unterschrift',
    documensoWidgetWaitingMany: '{0} Dokumente warten auf Ihre Unterschrift',
    documensoWidgetOpenButton: 'In Documenso öffnen',
    documensoWidgetEmptyState: 'Noch keine Dokumente. Legen Sie eine PDF ab, um zu beginnen.',
    documensoWidgetErrorMessage: 'Dokumente konnten nicht geladen werden.',
    documensoWidgetUnreachableMessage: 'Documenso ist nicht erreichbar.',
    documensoWidgetTokenInvalidMessage: 'Ihr Documenso-Token ist nicht mehr gültig. Bitte verbinden Sie sich erneut.',
    documensoWidgetReconnectButton: 'Erneut verbinden',
    documensoWidgetRetryButton: 'Erneut versuchen',
    documensoWidgetDialogOpenInNewTab: 'In neuem Tab öffnen',
    documensoWidgetDialogClose: 'Schließen',
    // DOCUMENSO FIELD EDITOR
    documensoEditorSignersLabel: 'Unterzeichnende',
    documensoEditorFieldTypeLabel: 'Feld zum Platzieren',
    documensoEditorTypeSignature: 'Unterschrift',
    documensoEditorTypeDate: 'Datum',
    documensoEditorTypeName: 'Name',
    documensoEditorPlaceHint:
        'Wählen Sie eine Person und ein Feld und klicken Sie dann auf die Stelle im Dokument. Ziehen Sie ein Feld, um es zu verschieben, und an der Ecke, um die Größe zu ändern.',
    documensoEditorMissingSignature: 'Braucht noch ein Unterschriftsfeld: {0}',
    documensoEditorSendButton: 'Zur Unterschrift senden',
    documensoEditorSending: 'Wird gesendet …',
    documensoEditorCustomizeLink: 'In Documenso anpassen',
    documensoEditorLoadError: 'Die PDF konnte nicht angezeigt werden.',
    documensoEditorSendFailed: 'Senden fehlgeschlagen. Bitte versuchen Sie es erneut.',
    documensoEditorInvalidFields: 'Einige Felder sind ungültig. Bitte prüfen Sie sie und versuchen Sie es erneut.',
    documensoEditorExistingWarning:
        'Dieser Entwurf hat {0} in Documenso platzierte Felder. Senden von hier ersetzt sie. Um sie zu behalten, senden Sie stattdessen aus Documenso:',
    documensoEditorRemoveBox: 'Feld entfernen',
    documensoEditorResizeBox: 'Feldgröße ändern',
    documensoEditorClose: 'Schließen',
    documensoEditorLoading: 'PDF wird geladen …',
    documensoEditorPageLabel: 'Seite {0}',
    coliboSettingsToggleLabel: 'Colibo',
    coliboSettingsConfiguredStatus: 'Konfiguriert',
    coliboSettingsNotConfiguredStatus: 'Nicht konfiguriert',
    coliboSettingsBaseUrlLabel: 'Colibo-Adresse',
    coliboSettingsBaseUrlHint: 'Die Adresse, unter der Ihre Mitarbeitenden Colibo öffnen, z. B. https://intranet.colibo.com',
    coliboSettingsClientIdLabel: 'OAuth-Client-ID',
    coliboSettingsClientSecretLabel: 'OAuth-Client-Secret',
    coliboSettingsClientSecretHint:
        'Legen Sie im Colibo-Admin einen OAuth-Client mit der unten stehenden Redirect-URI und den Scopes openid, profile, offline_access und api an.',
    coliboSettingsClientSecretKeepHint: 'Leer lassen, um das gespeicherte Secret zu behalten.',
    coliboSettingsRedirectUriLabel: 'In Colibo zu registrierende Redirect-URI',
    coliboSettingsInvalidError: 'Bitte geben Sie eine öffentliche https-Adresse, eine Client-ID und ein Client-Secret ein.',
    coliboSettingsSaveButton: 'Speichern',
    coliboSettingsCancelButton: 'Abbrechen',
    coliboCallbackConnecting: 'Ihr Colibo-Konto wird verbunden…',
    coliboCallbackSuccess: 'Colibo ist verbunden. Sie können dieses Fenster schließen.',
    coliboCallbackNoOpener: 'Colibo ist verbunden. Sie können dieses Fenster schließen und zu Ihrem Dashboard zurückkehren.',
    coliboCallbackError: 'Colibo konnte nicht verbunden werden. Bitte schließen Sie dieses Fenster und versuchen Sie es erneut.',
    coliboCallbackClose: 'Schließen'
};
